<template>
  <div>
    <template v-if="this.isDesktop === true">
      <!--       
        {{ watchdogCounter }}
      {{ lastUSBPath }}
      {{ watchdog.set }}
      {{ watchdog.enabled }}
      {{ watchdog.period }} 
    -->

      <v-tabs show-arrows="always" v-model="tabs" background-color="transparent">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.inspect") }}</v-tab>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.memory") }}</v-tab>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.triggers") }}</v-tab>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.events") }}</v-tab>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.settings") }}</v-tab>
        <v-tab class="my-2" :disabled="chartIsLoading">{{ $t("service.tabs.help") }}</v-tab>

        <v-tab class="ma-2" v-for="(item, i) in tabsRecorder" :key="'A' + i" v-on:click.right="deleteTabs(i, 'Recorder')" :disabled="chartIsLoading">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">{{ item }}</div>
            </template>
            <span>{{ $t("service.tabs.recorder.close") }}</span>
          </v-tooltip>
        </v-tab>

        <v-tab class="ma-2" v-for="(item, i) in tabsChart" :key="'B' + i" v-on:click.right="deleteTabs(i, 'Chart')" :disabled="chartIsLoading">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">{{ item }}</div>
            </template>
            <span>{{ $t("service.tabs.recorder.close") }}</span>
          </v-tooltip>
        </v-tab>

        <v-spacer />

        <v-btn :disabled="this.chartIsLoading == true || dataTableSelected == '' || tabsChart.length != 0" small color="primary" elevation="2" class="ma-2" @click="addTabs('Chart')">
          {{ $t("service.tabs.chart") }}
        </v-btn>

        <v-btn :disabled="this.chartIsLoading == true" small :color="recorder.runningState == 1 ? 'primary' : 'error'" elevation="2" class="ma-2" @click="addTabs('Recorder')">
          {{ $t("service.tabs.recorder.get") }}
        </v-btn>

        <template v-if="tabs == 0">
          <v-spacer />
          <v-select
            :menu-props="{
              bottom: true,
              offsetY: true,
              minHeight: windowHeight / 2,
              maxHeight: windowHeight / 2,
              minWidth: windowWidth / 3,
              maxWidth: windowWidth / 3,
            }"
            class="mx-2"
            id="SelectSetInspectPage"
            ref="SelectSetInspectPage"
            :disabled="port == null"
            @change="setInspectPage(false)"
            v-model="inspectPageSelect"
            :items="inspectPages"
            item-text="finalName"
            item-value="name"
            :label="inspectPageSelect == null ? $t('service.select') : null"
          ></v-select>
        </template>

        <!-- Inspect -->
        <v-tab-item class="ma-2">
          <v-row>
            <v-col cols="12">
              <template v-if="'image' in dataTableBackgroundItems">
                <v-row dense justify="center">
                  <v-col cols="12" align="center">
                    <v-img id="vizualizace" ref="vizualizace" :max-width="windowWidth - windowWidth / 3" :src="dataTableBackgroundItems.url">
                      <v-btn class="white--text" :id="'control' + item.index" :key="item.index" v-for="item in dataTableControlItems" x-small elevation="6" color="primary" @click="sendCommand(item)" :style="getImageControlStyle(item)">
                        {{ item.desc }}
                      </v-btn>
                      <span :id="'label' + item.id" :key="item.id" v-for="item in dataTableItems" :style="getImageSpanStyle(item)">
                        <template v-if="item.format == 'b' || item.intervalsDesc == true">
                          <b> {{ item.intervals }} </b> <br />
                        </template>
                        <b> {{ item.finalValue }} </b>
                      </span>
                    </v-img>
                  </v-col>
                </v-row>
              </template>

              <template v-else>
                <v-data-table dense :dark="$vuetify.theme.dark" :single-select="false" item-key="id" disable-pagination hide-default-footer :headers="dataTableHeader" :items="dataTableItems" class="elevation-12" @update:sort-by="dataTableSortByE">
                  <template v-slot:item="{ item }">
                    <!--                     <tr
                      :class="{
                        primary: item.id === dataTableSelectedId,
                      }"
                      :style="getStyle(item)"
                      @click="dataTableRowClick(item)"
                    > -->
                    <tr :style="getStyle(item)" @click="dataTableRowClick(item)">
                      <td class="text-right" width="1%">
                        <v-checkbox class="align-center justify-center" dense v-model="dataTableSelected" :value="item.id" :color="$vuetify.theme.dark ? 'white' : 'black'" hide-details></v-checkbox>
                      </td>

                      <td class="text-right" width="1%">
                        {{ item.selected }}
                      </td>
                      <td class="text-left" width="25%">
                        {{ item.finalName }}
                      </td>
                      <td class="text-left" width="25%" :style="getStyle2(item, 'finalValue')">
                        {{ item.finalValue }}
                      </td>
                      <td class="text-left" width="25%" :style="getStyle2(item, 'intervals')">
                        {{ item.intervals }}
                      </td>
                      <td class="text-right" width="1%">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mx-2" :color="getActionColor(item)" dark v-bind="attrs" v-on="on"> mdi-help-circle-outline </v-icon>
                          </template>
                          <span>
                            {{ $t("service.table.address") }}: {{ item.address }}+{{ item.offset }} <br />
                            {{ $t("service.table.type") }}: {{ item.type }}
                            <br />
                            <template v-if="item.format != null">
                              {{ $t("service.table.format") }}:
                              {{ item.format }}
                              <br />
                            </template>
                          </span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mx-2" :color="getActionColor(item)" dark v-bind="attrs" v-on="on" @click="setValue(item)"> mdi-pencil </v-icon>
                          </template>
                          <span>
                            {{ $t("service.table.actionsValue") }}
                          </span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mx-2" :color="getActionColor(item)" dark v-bind="attrs" v-on="on" @click="editItem(item)"> mdi-application-edit </v-icon>
                          </template>
                          <span>
                            {{ $t("service.table.actionsEdit") }}
                          </span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mx-2" :color="getActionColor(item)" dark v-bind="attrs" v-on="on" @click="deleteItem(item)"> mdi-delete </v-icon>
                          </template>
                          <span>
                            {{ $t("service.table.actionsDelete") }}
                          </span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>

                  <template v-slot:top>
                    <v-row>
                      <template v-if="dataTableControlItems.length != 0">
                        <v-col cols="12">
                          <v-slide-group show-arrows="always" active-class="success" class="mx-4">
                            <v-row justify="center" class="ma-2">
                              <v-slide-item v-for="item in dataTableControlItems" v-bind:key="item.id">
                                <v-btn x-small elevation="8" color="primary" class="ma-2 white--text" @click="sendCommand(item)">
                                  {{ item.desc }}
                                </v-btn>
                              </v-slide-item>
                            </v-row>
                          </v-slide-group>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12"></v-col>
                      </template>
                    </v-row>
                  </template>
                </v-data-table>
                <!--  </template> -->

                <v-data-table dense hide-default-footer hide-default-header disable-pagination :items="dataTableItems2" :headers="dataTableHeader2" class="elevation-12">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-right" width="1%"></td>
                      <td class="text-right" width="1%"></td>
                      <td class="text-left" width="25%">
                        <v-dialog v-model="dialog" max-width="600px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small plain :disabled="dataTableItems.length >= 30" :color="$vuetify.theme.dark ? 'white' : 'black'" v-bind="attrs" v-on="on">
                              <v-icon> mdi-plus </v-icon>
                              {{ item.C }}
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-row dense>
                                  <v-col cols="3">
                                    <v-text-field v-model="editedItem.desc" :label="$t('service.edit.desc')"></v-text-field>
                                  </v-col>

                                  <v-col cols="7">
                                    <v-autocomplete :items="variables.name" v-model="editedItem.name" :label="$t('service.edit.name')"></v-autocomplete>
                                  </v-col>

                                  <v-col cols="2">
                                    <v-text-field v-model="editedItem.units" :label="$t('service.edit.units')"></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col cols="12" sm="6" md="3">
                                    <v-select v-model="editedItem.type" :items="type" :label="$t('service.edit.type')"></v-select>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="3">
                                    <v-text-field type="number" v-model.number="editedItem.gain" :label="$t('service.edit.gain')"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="3">
                                    <v-text-field type="number" v-model.number="editedItem.offset" :label="$t('service.edit.offset')"></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="6" md="3">
                                    <v-text-field v-model="editedItem.format" :label="$t('service.edit.format')"></v-text-field>
                                  </v-col>
                                </v-row>

                                <!--                        
                            <v-row dense>
                              <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                  type="number"
                                  v-model.number="editedItem.len"
                                  :label="$t('service.edit.len')"
                                ></v-text-field>
                              </v-col>
                            </v-row> 
                            -->

                                <v-row no-gutters>
                                  <v-col cols="12">
                                    <v-text-field v-model="editedItem.style" :label="$t('service.edit.style')"></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col cols="6" align="center">
                                    <v-btn-toggle v-model="editedItem.btnTglFont" dense multiple>
                                      <v-btn>
                                        <v-icon>mdi-format-bold</v-icon>
                                      </v-btn>
                                      <v-btn>
                                        <v-icon>mdi-format-italic</v-icon>
                                      </v-btn>
                                      <v-btn>
                                        <v-icon>mdi-format-underline</v-icon>
                                      </v-btn>
                                    </v-btn-toggle>
                                  </v-col>
                                  <v-col cols="4" align="center">
                                    <v-btn-toggle v-model="editedItem.btnTglColor" dense multiple>
                                      <v-btn>
                                        <v-icon>mdi-format-color-fill</v-icon>
                                      </v-btn>
                                      <v-btn>
                                        <v-icon>mdi-format-color-highlight</v-icon>
                                      </v-btn>
                                    </v-btn-toggle>
                                  </v-col>
                                  <v-col cols="2" align="center">
                                    <v-btn dense @click="editedItem = Object.assign({}, defaultItem)">
                                      <v-icon>mdi-lock-reset</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col cols="12" align="center">
                                    <v-color-picker v-model="colorPicker" mode="hexa" hide-inputs></v-color-picker>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click="close">
                                {{ $t("service.dialog.close") }}
                              </v-btn>
                              <v-btn color="primary" text @click="save">
                                {{ $t("service.dialog.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </td>

                      <td class="text-right" width="25%"></td>
                      <td class="text-right" width="25%"></td>
                      <td class="text-right" width="1%"></td>
                    </tr>
                  </template>
                </v-data-table>

                <v-progress-linear :value="comm" height="8" color="primary"></v-progress-linear>
              </template>
            </v-col>
          </v-row>

          <v-row> </v-row>
        </v-tab-item>

        <!-- Utility -->
        <v-tab-item class="ma-2">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete :disabled="utility.start" v-model="utility.name" :items="variables.name" :label="$t('service.memory.name')" @change="utilityFindAddressForGivenName()"></v-autocomplete>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field :disabled="utility.start" v-model="utility.address" :label="$t('service.memory.address')"></v-text-field>
            </v-col>

            <v-col cols="6" md="1">
              <v-select :disabled="utility.start" v-model="utility.type" :items="type" :label="$t('service.memory.type')"></v-select>
            </v-col>

            <v-col cols="6" md="1">
              <v-text-field :disabled="utility.start" v-model="utility.len" type="number" :label="$t('service.memory.length')"></v-text-field>
            </v-col>

            <v-col cols="4" md="1">
              <v-checkbox :disabled="utility.start" v-model="utility.periodic" :label="$t('service.memory.periodicCall')"></v-checkbox>
            </v-col>

            <v-col cols="4" md="1">
              <v-checkbox :disabled="utility.start" v-model="utility.save" :label="$t('service.memory.saveToFile')"></v-checkbox>
            </v-col>

            <v-col cols="4" md="2">
              <v-btn small color="primary" class="my-4 mx-1" @click="utilityStart()">
                {{ this.utility.start == false ? $t("service.memory.start") : $t("service.memory.stop") }}
              </v-btn>
            </v-col>
          </v-row>

          <!-- <template v-if="utility.array.length !== 0"> -->
          <v-row>
            <v-col cols="12" md="5" lg="4" offset-lg="2" offset-md="1">
              <v-data-table dense :dark="$vuetify.theme.dark" :headers="dataTableUtilityHeader" :items="itemsUtilityHead" class="elevation-12" disable-pagination hide-default-footer>
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left" width="30%">
                      <!-- <v-chip small color="light-blue darken-1" dark> -->
                      {{ item.address }}
                      <!-- </v-chip> -->
                    </td>
                    <td class="text-left" width="5%">
                      <!-- <v-chip small color="cyan darken-1" dark> -->
                      {{ item.index }}
                      <!-- </v-chip> -->
                    </td>
                    <td class="text-right" width="30%">
                      <!-- <v-chip small color="teal darken-1" dark> -->
                      {{ item.value }}
                      <!-- </v-chip> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <v-data-table dense :dark="$vuetify.theme.dark" :headers="dataTableUtilityHeader" :items="itemsUtilityTail" class="elevation-12" disable-pagination hide-default-footer>
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left" width="30%">
                      <!-- <v-chip small color="light-blue darken-1" dark> -->
                      {{ item.address }}
                      <!-- </v-chip> -->
                    </td>
                    <td class="text-left" width="5%">
                      <!-- <v-chip small color="cyan darken-1" dark> -->
                      {{ item.index }}
                      <!-- </v-chip> -->
                    </td>
                    <td class="text-right" width="30%">
                      <!-- <v-chip small color="teal darken-1" dark> -->
                      {{ item.value }}
                      <!-- </v-chip> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <!-- </template> -->
        </v-tab-item>

        <v-tab-item class="ma-2">
          <!-- RunningState: {{ recorder.runningState }} LoadingState: {{ recorder.loadingState }} Loading: {{ recorder.loading }} -->
          <v-row>
            <v-col cols="12">
              <template v-if="'trigger' in recorder">
                <template v-if="recorder.trigger[0] == '00000000'">
                  <h4>
                    {{ $t("service.triggers.answer") }}:
                    {{ $t("service.triggers.noTrigger") }}
                  </h4>
                </template>
                <template v-else>
                  <h4>
                    {{ $t("service.triggers.answer") }}: {{ $t("service.triggers.address") }}: {{ recorder.trigger[0] }} {{ $t("service.triggers.type") }}:
                    {{ recorder.trigger[1] }}
                    {{ $t("service.triggers.operator") }}:
                    {{ recorder.trigger[2] }}
                    {{ $t("service.triggers.value") }}:
                    {{ recorder.trigger[3] }}
                  </h4>
                </template>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table dense :dark="$vuetify.theme.dark" :headers="dataTableTriggersHeader" :items="dataTableTriggersItems" class="elevation-12" disable-pagination hide-default-footer>
                <template v-slot:item="{ item }">
                  <tr :style="getTriggerStyle(item)">
                    <td class="text-left" width="1%">
                      <v-autocomplete dense :items="variables.name" v-model="item.name"></v-autocomplete>
                    </td>
                    <td class="text-left" width="1%">
                      <v-select dense v-model="item.cond" :items="operators"> </v-select>
                    </td>
                    <td class="text-left" width="1%">
                      <v-text-field dense v-model.number="item.value"></v-text-field>
                    </td>
                    <!--                     
                      <td class="text-left" width="1%">
                      {{ item.units }}
                      </td> 
                    -->

                    <td class="text-left" width="1%">
                      <v-select dense v-model="item.type" :items="type"> </v-select>
                    </td>
                    <td class="text-left" width="1%">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small class="mx-2" color="black" dark v-bind="attrs" v-on="on" @click="setTrigger(item)"> mdi-play </v-icon>
                        </template>
                        <span>
                          {{ $t("service.triggers.set") }}
                        </span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small class="mx-2" color="black" dark v-bind="attrs" v-on="on" @click="clearTrigger()"> mdi-stop </v-icon>
                        </template>
                        <span>
                          {{ $t("service.triggers.cancel") }}
                        </span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small class="mx-2" color="black" dark v-bind="attrs" v-on="on" @click="deleteTrigger(item)"> mdi-delete </v-icon>
                        </template>
                        <span>
                          {{ $t("service.triggers.delete") }}
                        </span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <v-data-table dense hide-default-footer hide-default-header disable-pagination :items="dataTableTriggersFooterItems" :headers="dataTableTriggersFooter" class="elevation-12">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left" width="1%">
                      <v-btn x-small plain :disabled="dataTableTriggersItems.length >= 30" :color="$vuetify.theme.dark ? 'white' : 'black'" @click="addTrigger()">
                        <v-icon> mdi-plus </v-icon>
                        {{ item.A }}
                      </v-btn>
                    </td>
                    <td class="text-right" width="1%"></td>
                    <td class="text-right" width="1%"></td>
                    <td class="text-right" width="1%"></td>
                  </tr>
                </template>
              </v-data-table>
              <v-progress-linear :value="comm" height="8" color="primary"></v-progress-linear>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item class="ma-2">
          <v-row>
            <v-col cols="12" md="6">
              <v-data-table dense :dark="$vuetify.theme.dark" :headers="dataTableEventsHeader" :items="dataTableEventsItems" class="elevation-12"></v-data-table>
              <v-progress-linear :value="comm" height="8" color="primary"></v-progress-linear>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- Nastavení -->
        <v-tab-item class="ma-2">
          <v-row dense>
            <v-col cols="12">
              <h4>{{ this.$i18n.t("service.settings.project") }}</h4>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <v-col cols="8" lg="4" md="6" align="center">
              <v-select dense :menu-props="{ auto: true, bottom: true, offsetY: true }" v-model="filesPath" :items="filesPaths" @change="changeProjectPointer()"> </v-select>
            </v-col>

            <v-col cols="1" align="start">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mx-2" color="primary" dark v-bind="attrs" v-on="on" @click="reloadFolders()"> mdi-refresh </v-icon>
                </template>
                <span>
                  {{ this.$i18n.t("service.settings.reloadFolders") }}
                </span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mx-2" color="primary" dark v-bind="attrs" v-on="on" @click="setDefaultRelease()"> mdi-content-save-all </v-icon>
                </template>
                <span>
                  {{ this.$i18n.t("service.settings.default") }}
                </span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <h4>{{ $t("service.settings.communication.name") }}</h4>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <v-col cols="12" md="6">
              <v-combobox v-model="port" :label="$t('service.settings.communication.usb')" @change="setPort(port)" clearable :items="ports" required></v-combobox>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <v-col cols="12" md="6" lg="3">
              <v-combobox :disabled="port != null && port != ''" v-model.number="serialSettings.baudRate" :label="$t('service.settings.communication.baudrate') + ' [Baud/s]'" :items="posibleBaudRates"> </v-combobox>
            </v-col>

            <v-col cols="12" md="6" lg="3"> <v-text-field :disabled="port != null && port != ''" v-model.number="serialSettings.dataBits" :label="$t('service.settings.communication.bits') + ' [-]'"> </v-text-field></v-col>

            <v-col cols="12" md="6" lg="3"> <v-text-field :disabled="port != null && port != ''" v-model.number="serialSettings.stopBits" :label="$t('service.settings.communication.stopBit') + ' [-]'"> </v-text-field></v-col>

            <v-col cols="12" md="6" lg="3">
              <v-text-field :disabled="port != null && port != ''" v-model="serialSettings.parity" :label="$t('service.settings.communication.parity') + ' [-]'"> </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <h4>{{ $t("service.settings.map") }}</h4>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <v-col cols="10" lg="6" md="8" align="center">
              <v-file-input dense :label="fileInputLabel" :value="fileInputValue" v-model="file" @change="onFileChange()" truncate-length="400"></v-file-input>
            </v-col>

            <v-col cols="1" align="start">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mx-2" color="primary" dark v-bind="attrs" v-on="on" @click="reloadMap()"> mdi-refresh </v-icon>
                </template>
                <span>
                  {{ this.$i18n.t("service.settings.refreshMap") }}
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="mx-2" color="primary" dark v-bind="attrs" v-on="on" @click="setDefaultMap()"> mdi-content-save-all </v-icon>
                </template>
                <span>
                  {{ this.$i18n.t("service.settings.default") }}
                </span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-row>
                <v-col cols="12">
                  <h4>{{ $t("service.settings.version.header") }}</h4>
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="version.ieee754Enabled" :label="$t('service.settings.version.IEEE-754')"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="version.inspectRequestWithEDCEnabled" :label="$t('service.settings.version.inspectRQEDC')"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="version.chartRequestWithEDCEnabled" :label="$t('service.settings.version.chartRQPartsEDC')"></v-checkbox>
                </v-col>
                <v-col cols="6"> </v-col>
                <v-col cols="6">
                  <v-combobox v-model.number="version.memorySize.current" :label="$t('service.settings.version.memorySize')" :items="version.memorySize.posibles"> </v-combobox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="12">
                  <h4>{{ $t("service.settings.detailedLog") }}</h4>
                </v-col>

                <v-col cols="3">
                  <v-checkbox v-model="detailedLog" :label="$t('service.settings.detailedLog')"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense class="ma-2">
            <!-- </v-row> -->

            <!-- <v-row dense> -->
            <v-col cols="12">
              <h4>{{ $t("service.settings.sampling.header") }}</h4>
            </v-col>

            <v-col cols="12" md="4" sm="8">
              {{ $t("service.settings.sampling.maxSamples") }} [-]
              <v-slider class="mt-8" :readonly="tabsChart.length > 0" v-model="samples.max" thumb-color="primary" :thumb-size="sliderThumbSize" min="10" max="1000" thumb-label="always" required></v-slider>
            </v-col>

            <v-col cols="12" md="4" sm="8">
              {{ $t("service.settings.sampling.rate") }} [s]
              <v-slider class="mt-8" :readonly="tabsChart.length > 0" v-model="timer.variableSample.period" thumb-color="primary" :thumb-size="sliderThumbSize" :step="0.1" :min="0.1" :max="30" thumb-label="always" required></v-slider>
            </v-col>
            <!-- </v-row> -->
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <h4>{{ $t("service.settings.events.header") }}</h4>
            </v-col>

            <v-col cols="12" md="4" sm="8">
              {{ $t("service.settings.events.maxEvents") }} [-]
              <v-slider class="mt-8" v-model="maxEvents" thumb-color="primary" :thumb-size="sliderThumbSize" min="20" max="1000" thumb-label="always" required></v-slider>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- Help -->
        <v-tab-item class="ma-2">
          <v-row>
            <v-col cols="12">
              <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown" reverse>
                <v-timeline-item color="red lighten-2" icon="mdi-keyboard" fill-dot>
                  <v-card color="red lighten-2" dark>
                    <v-card-title class="text-h6"> Klávesové zkratky </v-card-title>
                    <v-card-text class="white text--primary">
                      <v-row dense>
                        <v-col cols="12"> Dialogové obrazovky se mohou potvrdit klávesou <b>Enter</b> nebo ruší klávesou <b>ESC</b></v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Šipka nahoru / P</b></v-col>
                        <v-col cols="9"> Posun označení nahoru konkrétní proměnné v tabulce</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Šipka dolu / L</b></v-col>
                        <v-col cols="9"> Posun označení dolu konkrétní proměnné v tabulce</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Šipka doleva</b></v-col>
                        <v-col cols="9"> Přepnutí inspektové sady na nižší</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Šipka doprava</b></v-col>
                        <v-col cols="9"> Přepnutí inspektové sady na vyšší</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>A</b></v-col>
                        <v-col cols="9"> Přidání proměnné, (maximální počet proměnné na stránku je 30)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>E</b> </v-col>
                        <v-col cols="9"> Editace proměnné, (Otevření dialogového okna na označeným řádku šipkou)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>X</b></v-col>
                        <v-col cols="9"> Smazání proměnné, (Smazání proměnné na označeným řádku šipkou)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>D</b></v-col>
                        <v-col cols="9"> Duplikace proměnné, (Duplikace proměnné na označeným řádku šipkou)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"><b>O</b> </v-col>
                        <v-col cols="9"> Posun proměnné nahoru, (Posun proměnné nahoru na označeným řádku šipkou)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>K</b></v-col>
                        <v-col cols="9"> Posun proměnné nahoru, (Posun proměnné dolu na označeným řádku šipkou)</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>S</b> </v-col>
                        <v-col cols="9"> Uložení inspektové sady inspectXXX.json </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>I</b></v-col>
                        <v-col cols="9"> Otevření comboboxu pro výběr sad</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Z / V</b></v-col>
                        <v-col cols="9"> Zadání nové hodnoty, (Zadaní nové hodnoty pro označenou proměnnou) </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>H</b></v-col>
                        <v-col cols="9"> Pro proměnné ve formatu binary ("format": "b"), lze otevřít dialog pro nastavování (SET/CLR) jednotlivých bitů. Vhodné i pro přehledné zobrazení aktivních bitů pro read-only proměnnou </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>C</b></v-col>
                        <v-col cols="9"> Vynulování minima a maxima celé tabulky</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Mezerník</b> </v-col>
                        <v-col cols="9"> Označení / Odoznačení řádku v tabulce</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>0-9</b> </v-col>
                        <v-col cols="9"> Lze přepnout inspektovou sadu pomocí čísel. Rozsah je 0-255. Sekvence po sobě jdoucích čísel do určitého času (max 0,8s) zadá požadavek na konkrétní sadu "1""0""0" -> Inspektová sada je nastavena na 100. </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>Mezerník</b> </v-col>
                        <v-col cols="9"> Označení / Odoznačení řádku v tabulce</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>+</b> </v-col>
                        <v-col cols="9"> Increment proměnné (Intové typy increment proměnné o 1, Floatové typy increment proměnné podle počtu desetinných míst. Např F2 odečítá proměnnou o 0,01) </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>-</b> </v-col>
                        <v-col cols="9"> Decrement proměnné (Intové typy decrement proměnné o 1, Floatové typy decrement proměnné podle počtu desetinných míst. Např F2 odečítá proměnnou o 0,01) </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12"> <b>Trigery</b> - Přidávání a mazání proměnných, spouštění a zastavování trigerů se provádí pomocí tlačítek na obrazovce </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="3"> <b>S</b> </v-col>
                        <v-col cols="9"> Uložení tabulky trigerů do triggers.json </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>

                <v-timeline-item color="purple darken-1" icon="mdi-file-tree-outline" fill-dot>
                  <v-card color="purple darken-1" dark>
                    <v-card-title class="text-h6"> Popis struktury souborů a adresářů </v-card-title>
                    <v-card-text>
                      <v-row style="color: white">
                        <v-col cols="12"> Příklad struktůry souborů a adresářů </v-col>
                      </v-row>

                      <v-treeview dense v-model="treeItem" :items="treeItems" item-key="id" open-on-click open-all activatable @update:active="treeViewGetActiveValue">
                        <template v-slot:prepend="{ item, open }">
                          <v-icon v-if="!item.file">
                            {{ open ? "mdi-folder-open" : "mdi-folder" }}
                          </v-icon>
                          <v-icon v-else> mdi-file </v-icon>
                        </template>
                      </v-treeview>
                    </v-card-text>
                    <v-card-subtitle>
                      <template v-if="treeFileName != ''">
                        <v-card>
                          <v-card-title style="color: cyan; background-color: #424242"> {{ treeFileName }} </v-card-title>

                          <v-card-text style="color: #f9a825; background-color: #424242">
                            <div v-html="treeFileSubName"></div>
                          </v-card-text>
                          <v-card-text style="color: lightgreen; background-color: #424242">
                            <div v-html="treeFileDesc"></div>
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-card-subtitle>
                  </v-card>
                </v-timeline-item>

                <v-timeline-item color="green lighten-1" icon="mdi-information-outline" fill-dot>
                  <v-card color="green lighten-1" dark>
                    <v-card-title class="text-h6"> Tipy </v-card-title>
                    <v-card-text class="white text--primary"> ... </v-card-text>
                  </v-card>
                </v-timeline-item>

                <v-timeline-item color="indigo" icon="mdi-tooltip-text-outline" fill-dot>
                  <v-card color="indigo" dark>
                    <v-card-title class="text-h6"> Ostatní </v-card-title>
                    <v-card-text class="white text--primary"> ... </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item v-for="(item, i) in tabsRecorder" :key="'C' + i">
          <v-card>
            <v-card-title>
              <v-row>
                <v-col cols="12" align="start">
                  <h4>{{ $t("service.tabs.recorder.name") }}</h4>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <ApexLineChart :enabled="rdRenderEN[i]" :data="rd[i]" :height="windowHeight - 240" :dark="$vuetify.theme.dark" />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item v-for="(item, i) in tabsChart" :key="'D' + i">
          <v-card>
            <v-card-title>
              <v-row>
                <v-col cols="12" align="start">
                  <h4>{{ $t("service.tabs.chart") }}</h4>
                </v-col>
                <v-col cols="12" align="center">
                  <template v-if="timer.variableSample.enabled === false">
                    <v-btn color="primary" text @click="timer.variableSample.enabled = true"> <v-icon> mdi-play </v-icon>{{ $t("service.chart.play") }} </v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="primary" text @click="timer.variableSample.enabled = false"> <v-icon> mdi-pause </v-icon>{{ $t("service.chart.pause") }} </v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <ApexRealTimeChart :enabled="timer.variableSample.enabled" :data="rt" :rate="timer.variableSample.period" />
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col cols="12" align="center">
                  <template v-if="rtShowGains === true">
                    <v-btn color="primary" text @click="rtShowGains = false"> <v-icon> mdi-minus </v-icon>{{ $t("service.chart.hideGain") }}</v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="primary" text @click="rtShowGains = true"> <v-icon> mdi-plus </v-icon>{{ $t("service.chart.showGain") }}</v-btn>
                  </template>
                </v-col>
                <template v-if="rtShowGains === true">
                  <v-col cols="2" v-for="(item, index) in rt" :key="index">
                    <v-row>
                      <v-col cols="2">
                        <v-avatar :color="inspectChartsColors[index]" size="20"></v-avatar>
                      </v-col>
                      <v-col cols="10">
                        <v-text-field v-model="item.gain" @input="recalculateRealtimeChartGain(item)" dense :label="item.name" prefix="x"> </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-snackbar v-model="snackbarError" color="error" bottom text>
        {{ snackbarErrorText }}
      </v-snackbar>

      <v-snackbar v-model="snackbarInfo" color="info" bottom right text :timeout="snackbarInfoTimeout">
        <div v-for="(text, index) in snackbarInfoText.split('\n')" :key="'E' + index">
          {{ text }}
        </div>
      </v-snackbar>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">{{ $t("service.dialog.closeConfirm") }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeDelete">{{ $t("service.dialog.cancel") }}</v-btn>
            <v-btn color="primary" text @click="deleteItemConfirm">{{ $t("service.dialog.ok") }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSetVar" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">{{ $t("service.dialog.value") }}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field id="TextFieldSetVar" ref="TextFieldSetVar" v-model="setVariable.value" :label="$t('service.dialog.val')"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeSetVar">{{ $t("service.dialog.cancel") }}</v-btn>
            <v-btn color="primary" text @click="saveSetVar">{{ $t("service.dialog.ok") }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogBits" :max-width="0.5 * windowWidth" :min-width="250">
        <v-card>
          <v-card-text>
            <v-container>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th width="1%">Bit</th>
                    <th>Description</th>
                    <th width="1%">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bit, i) in currentBits" :key="i" :style="getBitTableRowStyle(bit)" @click="tglBitTableRowClick(bit)">
                    <td>{{ bit.index }}</td>
                    <td>{{ bit.desc }}</td>
                    <td>{{ bit.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div class="overflow-hidden">
        <v-bottom-navigation color="primary" horizontal app fixed>
          <span class="ma-4 text-caption">{{ $t("service.recievedCode") }}: {{ checkSumRecivedData }}</span>
          <span class="ma-4 text-caption">{{ $t("service.calculatedCode") }}: {{ checkSumTransmitedData }} </span>
          <span class="ma-4 text-caption">{{ $t("service.errorMessages") }}: {{ errorMessagesCounter }}</span>
          <span class="ma-4 text-caption">{{ $t("service.watchdogTotalReconnects") }}: {{ watchdogTotalReconnects }}</span>

          <span class="ma-4 text-caption">RX-WDTRep: {{ (Math.round(watchdogCounterRepeat * 10) / 10).toFixed(0) }} </span>
          <span class="ma-4 text-caption">{{ $t("service.watchdogCounter") }}: {{ (Math.round(watchdogCounter * 10) / 10).toFixed(1) }} s </span>
          <span class="ma-4 text-caption">{{ $t("service.watchdogCounterMax") }}: {{ (Math.round(watchdogCounterMax * 10) / 10).toFixed(1) }} s</span>
        </v-bottom-navigation>
      </div>
    </template>
    <template v-else>
      <v-row>
        <v-col align="center" class="text-h6">
          {{ $t("service.notDesktop") }}
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { isElectron } from "../../platform.js";

import * as MyDate from "../../serviceapp/date.js";
import * as MyMath from "../../serviceapp/math.js";
import * as MyVariables from "../../serviceapp/variables.js";
import * as MySerial from "../../serviceapp/serial.js";
import * as MyString from "../../serviceapp/string.js";
import * as MyJSON from "../../serviceapp/json.js";
import * as MyTriggers from "../../serviceapp/triggers.js";

import { inspectChartsColors } from "../../colors.js";

import ApexLineChart from "../../components/charts/apexcharts/ApexLineChart.vue";
import ApexRealTimeChart from "../../components/charts/apexcharts/ApexRealTimeChart.vue";

import Snackbar from "../../components/snackbar/Snackbar.vue";

const constStaticTabs = 6;

const constSelected = "->";
const constNotSelected = "";

const constDebugMode = true;

const constBitDescLen = 32;

const constMaximumRealtimeCharts = 1;
const constMaximumRecorderCharts = 10;

const parseMapkeyX = "                ";
const parseMapkey1 = parseMapkeyX + "0x20";
const parseMapkey2 = parseMapkeyX + "0x0000000020";
const parseMapkey3 = parseMapkeyX + "0x0000000024";
const parseMapkey4 = parseMapkeyX + "0x24";

var SerialPort = null;
var ReadlineParser = null;

var Port = null;
var Parser = null;

var FileSystem = null;
var FilePath = null;

export default {
  name: "ServiceApp",
  components: {
    ApexLineChart,
    ApexRealTimeChart,
    Snackbar,
  },
  data() {
    return {
      requestLast: "",

      architecture: 64,

      treeFileName: "",
      treeFileSubName: "",
      treeFileDesc: "",
      treeItem: [],
      treeItems: [
        {
          id: 1,
          name: "data",
          children: [
            {
              id: 10,
              name: "Projekt č.1",
              children: [
                {
                  id: 101,
                  name: "Projekt1a",
                  children: [
                    {
                      id: 1001,
                      name: "inspect000.json",
                      file: "json",
                    },
                    {
                      id: 1002,
                      name: "customConfig.json",
                      file: "json",
                    },
                  ],
                },
                {
                  id: 102,
                  name: "Projekt1b",
                  children: [
                    {
                      id: 1021,
                      name: "output.map",
                      file: "map",
                    },
                    {
                      id: 1022,
                      name: "inspect000.json",
                      file: "json",
                    },
                    {
                      id: 1023,
                      name: "inspect001.json",
                      file: "json",
                    },
                    {
                      id: 1024,
                      name: "inspect002.json",
                      file: "json",
                    },
                    {
                      id: 1025,
                      name: "recorder.json",
                      file: "json",
                    },
                    {
                      id: 1026,
                      name: "trigers.json",
                      file: "json",
                    },
                    {
                      id: 1027,
                      name: "events.json",
                      file: "json",
                    },
                    {
                      id: 1028,
                      name: "variable-vals.json",
                      file: "json",
                    },
                    {
                      id: 1029,
                      name: "customConfig.json",
                      file: "json",
                    },
                  ],
                },
                {
                  id: 103,
                  name: "Projekt1c",
                  children: [
                    {
                      id: 1031,
                      name: "inspect000.json",
                      file: "json",
                    },
                    {
                      id: 1032,
                      name: "customConfig.json",
                      file: "json",
                    },
                  ],
                },
              ],
            },
            {
              id: 20,
              name: "Projekt č.2",
              children: [
                {
                  id: 201,
                  name: "inspect000.json",
                  file: "json",
                },
                {
                  id: 2011,
                  name: "customConfig.json",
                  file: "json",
                },
              ],
            },
            {
              id: 30,
              name: "Projekt č.3",
              children: [
                {
                  id: 301,
                  name: "output.map",
                  file: "map",
                },
                {
                  id: 302,
                  name: "inspect000.json",
                  file: "json",
                },
                {
                  id: 303,
                  name: "inspect001.json",
                  file: "json",
                },
                {
                  id: 304,
                  name: "inspect002.json",
                  file: "json",
                },
                {
                  id: 305,
                  name: "recorder.json",
                  file: "json",
                },
                {
                  id: 306,
                  name: "trigers.json",
                  file: "json",
                },
                {
                  id: 307,
                  name: "events.json",
                  file: "json",
                },
                {
                  id: 308,
                  name: "variable-vals.json",
                  file: "json",
                },
                {
                  id: 309,
                  name: "customConfig.json",
                  file: "json",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          name: "EDS.AppImage",
          file: "json",
        },
        {
          id: 3,
          name: "EDS.exe",
          file: "json",
        },
        {
          id: 4,
          name: "ECSConfig.json",
          file: "json",
        },
        {
          id: 5,
          name: "ECSVariables.json",
          file: "json",
        },
        {
          id: 6,
          name: "variables-desc.json",
          file: "json",
        },
      ],

      watchdogCounter: 0, // s
      //watchdogCounterMax: 1.5, //1.5, // s
      watchdogCounterRepeat: 0,
      watchdogCounterMax: 1, //1.5, // s

      watchdogTotalReconnects: 0,
      lastUSBPath: "",

      errorMessagesCounter: 0,
      checkSumRecivedData: "000",
      checkSumTransmitedData: "000",

      timeoutPageBuffer: null,
      changePageBuffer: "",

      // TODO Pozdeji vyčítat a ukladát z ECSConfig.json
      maxEvents: 80,

      version: {
        ieee754Enabled: true,
        inspectRequestWithEDCEnabled: true,
        chartRequestWithEDCEnabled: true,
        memorySize: {
          current: 32,
          posibles: [32, 16],
        },
      },

      detailedLog: false,

      sliderThumbSize: "24",

      poolWasActive: false,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      config: null,

      ECSVariables: null,

      snackbarError: false,
      snackbarErrorText: "",

      snackbarInfo: false,
      snackbarInfoText: "",
      snackbarInfoTimeout: 6000,

      comm: null,
      commDelay: null,

      tabs: 0,
      tabsRecorder: [],
      tabsChart: [],

      colorPicker: {},

      inspectChartsColors: inspectChartsColors,

      styleFont: "",
      styleColor: "",

      dialog: false,
      dialogDelete: false,
      dialogSetVar: false,
      dialogBits: false,

      setVariable: {
        address: 0,
        typeValue: "",
        type: "",
        value: "",
      },

      /*
        "select"
        "selected"
        "finalName"
        "name"
        "desc"
        "finalValue"
        "intervals"
        "actions"
        "value"
        "units"
        "intervalA"
        "intervalB"
        "finalAddress"
        "style"
        "address"
        "offset"
        "type"
        "format"
        "detail"
      */
      dataTableHeader: [
        {
          text: this.$i18n.t("service.table.select"),
          align: "start", //
          value: "select", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.selected"),
          align: "start", //
          value: "selected", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.finalName"),
          align: "start", //
          value: "finalName", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.finalValue"),
          align: "start", //
          value: "finalValue", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.intervals"),
          align: "start", //
          value: "intervals", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.actions"),
          align: "start", //
          value: "actions", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
      ],
      dataTableEventsHeader: [
        {
          text: this.$i18n.t("service.table.time"),
          align: "start", //
          value: "tm", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.variableCode"),
          align: "start", //
          value: "vc", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.variableValue"),
          align: "start", //
          value: "vv", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
      ],
      dataTableUtilityHeader: [
        {
          text: this.$i18n.t("service.table.address"),
          align: "start", //
          value: "address", //
          sortable: false, //
          width: "30%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.index"),
          align: "start", //
          value: "index", //
          sortable: false, //
          width: "5%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.value"),
          align: "end", //
          value: "value", //
          sortable: false, //
          width: "30%", //
          fixed: true, //
        },
      ],
      dataTableTriggersHeader: [
        {
          text: this.$i18n.t("service.table.name"),
          align: "start", //
          value: "name", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.cond"),
          align: "start", //
          value: "cond", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.value"),
          align: "start", //
          value: "value", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
        /*
        {
          text: "Jednotka",
          align: "start", //
          value: "units", //
          sortable: false, //
          width: "10%", //
          fixed: true, //
        },
        */
        {
          text: this.$i18n.t("service.table.type"),
          align: "start", //
          value: "type", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: this.$i18n.t("service.table.actions"),
          align: "start", //
          value: "actions", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
      ],
      dataTableTriggersFooter: [
        {
          text: "",
          align: "start", //
          value: "A", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "A", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "A", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "A", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
      ],
      dataTableTriggersFooterItems: [
        {
          A: this.$i18n.t("service.table.add"),
          B: "",
          C: "",
          D: "",
        },
      ],

      dataTableItems: [],
      dataTableControlItems: [],
      dataTableBackgroundItems: [],
      dataTableEventsItems: [],
      dataTableTriggersItems: [],

      dataTableSelected: [],
      dataTableSelectedId: 0,

      dataTableHeader2: [
        {
          text: "",
          align: "start", //
          value: "A", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "B", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "C", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "D", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "E", //
          sortable: false, //
          width: "25%", //
          fixed: true, //
        },
        {
          text: "",
          align: "start", //
          value: "F", //
          sortable: false, //
          width: "1%", //
          fixed: true, //
        },
      ],
      dataTableItems2: [
        {
          A: "",
          B: "",
          C: this.$i18n.t("service.table.add"),
          D: "",
          E: "",
          F: "",
        },
      ],

      currentBits: [],

      editedIndex: -1,

      editedItem: {
        name: "",
        finalName: "",
        format: "",
        gain: 1,
        offset: 0,
        len: 0,
        style: "",
        type: "U32",
        units: "",

        color: "",
        backgroundColor: "",

        btnTglFont: [],
        styleFont: "",
        btnTglColor: [],
        styleColor: "",
      },
      defaultItem: {
        name: "",
        finalName: "",
        format: "",
        gain: 1,
        offset: 0,
        len: 0,
        style: "",
        type: "U32",
        units: "",

        color: "",
        backgroundColor: "",

        btnTglFont: [],
        styleFont: "",
        btnTglColor: [],
        styleColor: "",
      },

      mobile: false,

      port: null,
      ports: [],
      portsObj: [],

      file: null,

      fileInputLabel: "",
      fileInputValue: "",

      outputMap: [],
      parsedMap: [],

      recorder: [],
      inspect: [],
      events: [],
      chart: [],

      rd: [], // array of recorders
      rdRenderEN: [], // array of boolean of enabled updates for recorders

      rt: [],
      rtShowGains: false,

      recorderCurrentSample: 0,
      recorderMaximumSamples: 0,

      chartIsLoading: false,

      recorderJSON: [],
      triggerJSON: [],

      variables: {
        address: [],
        name: [],
      },

      utility: {
        name: "",
        address: "",
        type: "U32",
        len: 0,
        periodic: false,
        periodFinished: false,
        save: false,
        file: "",
        start: false,
        timer: null,
        currentSeq: 0,
        totalSeq: 0,
        next: true,
        /*finalNext: true,*/
        array: [],
      },

      baudrateOverwriten: false,

      mapFound: false,

      serialSettings: {
        baudRate: 115200,
        dataBits: 8,
        stopBits: 1,
        parity: "none",
      },

      paths: [],

      isDesktop: false,

      posibleBaudRates: MySerial.Baudrates,

      type: MyVariables.Type,

      operator: MyTriggers.Operators[0],
      operators: MyTriggers.Operators,

      inspectPages: [],
      inspectPageSelect: null,
      inspectPageSelectId: null,
      inspectPageHasBeenChanged: false,

      variablesDesc: [],
      variablesVals: [],

      files: [],

      filesPath: null,
      filesPaths: [],

      samples: {
        max: 80,
        log: false,
      },

      timer: {
        portScan: {
          set: null,
          period: 3000,
        },
        portWrite: {
          set: null,
          enabled: false,
          period: 175, //125, //175, //200, // 175,
        },
        variableSample: {
          set: null,
          enabled: false,
          period: 1, // s
        },
        requestChart: {
          set: null,
          enabled: false,
          period: 100, // ms
        },
        watchdog: {
          set: null,
          enabled: false,
          period: 100, // ms
        },
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$i18n.t("service.dialog.new") : this.$i18n.t("service.dialog.edit");
    },
    itemsUtilityHead() {
      return this.utility.array ? this.utility.array.slice(0, Math.round((this.utility.array.length * 1) / 2)) : [];
    },
    itemsUtilityTail() {
      return this.utility.array ? this.utility.array.slice(Math.round((this.utility.array.length * 1) / 2)) : [];
    },
  },

  methods: {
    searchObjectById(objectArray, id) {
      for (let i = 0; i < objectArray.length; i++) {
        const object = objectArray[i];

        if (object.id === id) {
          return object.name;
        }

        if (object.children && object.children.length > 0) {
          const result = this.searchObjectById(object.children, id);
          if (result) {
            return result;
          }
        }
      }

      return null;
    },
    treeViewGetActiveValue(value) {
      let l = this.searchObjectById(this.treeItems, value[0]);

      switch (l) {
        case "output.map":
          this.treeFileName = l;
          this.treeFileSubName = "Tento soubor poskytuje SW developer. Aplikace hledá jakýkoliv soubor s příponou .map ";
          this.treeFileDesc = "Soubory s příponou output .map ....";
          break;
        case "customConfig.json":
          this.treeFileName = l;
          this.treeFileSubName = "Slouží pro přepsání globální konfigurace komunikační rychlosti v ECSConfig.json pro jednotlivý projekt. <br /> - Baudrate - Přenosová rychlost";
          this.treeFileDesc = "{ <br /> " + "&emsp; 'baudrate': 115200 <br /> " + "} <br />";
          break;
        case "inspect000.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "inspect000.json";
          break;
        case "inspect001.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "inspect001.json";
          break;
        case "inspect002.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "inspect002.json";
          break;
        case "recorder.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "recorder.json";
          break;
        case "events.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "events.json";
          break;
        case "trigers.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "trigers.json";
          break;
        case "variable-vals.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "variable-vals.json";
          break;
        case "variables-desc.json":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "variables-desc.json";
          break;
        case "ECSVariables.json":
          this.treeFileName = l;
          this.treeFileSubName = "Globální definiční soubor pro zjednodušení práce s inspektovými sadami. ";
          this.treeFileDesc = "ECSVariables.json";
          break;
        case "ECSConfig.json":
          this.treeFileName = l;
          this.treeFileSubName =
            "Globální konfigurace aplikace. Je hledána vždy, odkud se spouští aplikace.  <br /> - variableDesc - Cesta ke globálnímu souboru s popiskama proměnných, které generuje c-linux <br /> - port - Preferovaný port  (Linux - '/dev/ttyUSB0', ... Windows - 'COM1', ...) (lze měnit v APP)  <br /> - baudrate - Komunikační rychlost (lze měnit i v APP) <br /> - Release - Preferovaná cesta k danému projektu (lze měnit i v APP)";
          this.treeFileDesc = "{ <br /> " + "&emsp; 'variableDesc': 'variables-desc.json', <br /> " + "&emsp; 'port': '/dev/ttyUSB0', <br /> " + "&emsp; 'baudrate': 230400, <br /> " + "&emsp; 'release': 'data/Inverter/inverter3f' <br /> " + "} <br />";
          break;
        case "EnergyCloud.AppImage":
          this.treeFileName = l;
          this.treeFileSubName = "";
          this.treeFileDesc = "EnergyCloud.AppImage";
          break;
        default:
          this.treeFileName = "";
          this.treeFileSubName = "";
          this.treeFileDesc = "";
          break;
      }
    },
    parseMap(string) {
      // Let's split map into Array
      this.outputMap = string.split("\n");

      // Every time parseMap method is called
      // parsedMap array is reseted
      this.parsedMap = [];
      // variables object of arrays is reseted
      this.variables = {
        address: [],
        name: [],
      };

      let parsedMapIndex = 0;

      // Individual elements are searched and we are only interested in items that show SRAM variable names and addresses
      for (let index = 0; index < this.outputMap.length; index++) {
        let RAMBase1Found32Bit = this.outputMap[index].includes(parseMapkey1) || this.outputMap[index].includes(parseMapkey4);
        let RAMBase2Found64Bit = this.outputMap[index].includes(parseMapkey2) || this.outputMap[index].includes(parseMapkey3);

        let noEqualFound = !this.outputMap[index].includes("=");
        let noDotFound = !this.outputMap[index].includes(".");
        let noSlashFound = !this.outputMap[index].includes("/");

        if (RAMBase1Found32Bit && noEqualFound && noDotFound && noSlashFound) {
          this.architecture = 32;
          this.$set(this.parsedMap, parsedMapIndex, this.outputMap[index]);
          parsedMapIndex++;
        } else if (RAMBase2Found64Bit && noEqualFound && noDotFound && noSlashFound) {
          this.architecture = 64;
          this.$set(this.parsedMap, parsedMapIndex, this.outputMap[index]);
          parsedMapIndex++;
        }
      }

      // Loop through interesting values for us
      for (let i = 0; i < this.parsedMap.length; i++) {
        // If more than one address is found on one line, the line is ignored
        let num = this.parsedMap[i].match(/0x/g);
        if (num.length > 1) {
          break;
        }

        // Auxiliary variables
        let addressFirstIndex = 0;
        let addressLastIndex = 0;
        let nameFirstIndex = 0;
        let nameLastIndex = 0;

        // Find the index where the address of the variable begins
        for (let j = 0; j < this.parsedMap[i].length; j++) {
          if (this.parsedMap[i].charAt(j) !== " ") {
            addressFirstIndex = j;
            break;
          }
        }
        // Find the index where the address of the variable ends
        for (let j = addressFirstIndex; j < this.parsedMap[i].length; j++) {
          if (this.parsedMap[i].charAt(j) === " ") {
            addressLastIndex = j;
            break;
          }
        }
        // Find the index where the address of the name begins,
        for (let j = addressLastIndex; j < this.parsedMap[i].length; j++) {
          if (this.parsedMap[i].charAt(j) !== " ") {
            nameFirstIndex = j;
            break;
          }
        }
        // Where name ends is no needed for search, because it's the end of the string (lenght)
        nameLastIndex = this.parsedMap[i].length;

        // Variable address is extracted into Array
        this.$set(
          this.variables.address,
          i,
          this.parsedMap[i].substr(addressFirstIndex, addressLastIndex).toUpperCase().trim() // Some white spaces are visiable at adress, let's trimm that
        );

        // Variable name is extracted into Array
        this.$set(this.variables.name, i, this.parsedMap[i].substr(nameFirstIndex, nameLastIndex).trim());

        // Reset auxiliary variables for next line
        addressFirstIndex = 0;
        addressLastIndex = 0;
        nameFirstIndex = 0;
      }

      // It's no longer needed to hold these big datas
      this.outputMap = [];
      this.parsedMap = [];
    },

    utilityFindAddressForGivenName() {
      for (let index = 0; index < this.variables.name.length; index++) {
        if (this.variables.name[index] === this.utility.name) {
          this.$set(this.utility, "address", this.variables.address[index]);
          break;
        }
      }
    },
    utilityPoll() {
      if (this.utility.array.length <= 0) {
        return;
      }

      this.utility.totalSeq = Math.ceil(this.utility.array.length / 20);

      this.utility.currentSeq++;
      if (this.utility.currentSeq > this.utility.totalSeq) {
        if (this.utility.periodic == true) {
          this.utility.currentSeq = 1;
        } else {
          this.utilityStart();
        }

        if (this.utility.save === true) {
          this.utility.periodFinished = true;
        }
      }

      if (this.utility.save === true) {
        let saveRow = "";
        if (this.utility.periodFinished === true) {
          for (let index = 0; index < this.utility.array.length; index++) {
            saveRow += this.utility.array[index].value + ";";

            if (index == this.utility.array.length - 1) {
              saveRow += "\n";
            }
          }
          FileSystem.appendFileSync(this.utility.file, saveRow);
          this.snackbarInfo = true;
          this.snackbarInfoText = this.$i18n.t("service.snackbar.dataSaved");
          this.utility.periodFinished = false;
        }
      }

      let start = this.utility.currentSeq * 20 - 20;
      let end = this.utility.currentSeq * 20;

      if (end > this.utility.array.length) {
        end = this.utility.array.length;
      }

      let offsetSRAM = "";
      let variables = "";
      let pageIndex = this.utility.currentSeq.toString(16).toUpperCase();

      if (pageIndex.length == 1) {
        pageIndex = "0" + pageIndex;
      }

      /*       
      console.log("currentSeq", this.utility.currentSeq);
      console.log("totalSeq", this.utility.totalSeq);
      console.log("start", start);
      console.log("end", end); 
      */

      let addressLen = 0;
      let dbgIs = "";

      if (this.version.memorySize.current == 32) {
        addressLen = 8;
        dbgIs = "DBG:is2:";
      } else if (this.version.memorySize.current == 16) {
        addressLen = 4;
        dbgIs = "DBG:is:";
      }

      for (let index = start; index < end; index++) {
        offsetSRAM = this.utility.array[index].address.substr(this.utility.array[index].address.length - addressLen, this.utility.array[index].address.length);

        variables += offsetSRAM + "," + MyVariables.GetTypeValue(this.utility.type) + ";";
      }

      let request = dbgIs + pageIndex + ";" + variables + "\n";

      this.portWrite(request, false);
    },
    utilityStart() {
      if (this.utility.timer != null) {
        clearInterval(this.utility.timer);
      }

      if (this.utility.start == true) {
        this.utility.start = false;

        let dbgIs = "";

        if (this.version.memorySize.current == 32) {
          dbgIs = "DBG:is2:";
        } else if (this.version.memorySize.current == 16) {
          dbgIs = "DBG:is:";
        }

        let request = dbgIs + "00" + ";" + "\n";

        this.portWrite(request, false);

        return;
      } else {
        this.utility.start = true;
      }

      this.utility.array = [];

      let obj;
      let offset = MyVariables.GetTypeByteSize(this.utility.type);

      this.utility.array = [];
      this.utility.currentSeq = 0;
      this.utility.totalSeq = 0;
      this.utility.len = this.utility.len > 1960 ? 1960 : this.utility.len < 0 ? 0 : this.utility.len;

      if (this.utility.len == 0) {
        return;
      }

      let saveHeader1 = "";
      let saveHeader2 = "";

      for (let index = 0; index < this.utility.len; index++) {
        obj = {
          address: "0X00000000" + (parseInt(this.utility.address, 16) + index * offset).toString(16).toUpperCase(),
          index: index,
          value: 0,
        };

        saveHeader1 += obj.address + ";";
        saveHeader2 += obj.index + ";";

        this.utility.array.push(obj);
      }

      if (this.utility.save == true) {
        let saveHeader = saveHeader1 + "\n" + saveHeader2 + "\n";

        this.utility.file = MyDate.GetDayAndTime_YYYYMMDDHHMMSS() + ".csv";

        FileSystem.writeFile(this.utility.file, saveHeader, function (err) {
          if (err) {
            return console.log(err);
          }

          this.snackbarInfo = true;
          this.snackbarInfoText = this.$t("service.snackbar.fileCreated");
        });
      }

      if (this.utility.start == true) {
        this.utility.timer = setInterval(() => {
          if (this.utility.next == true) {
            /* if (this.utility.finalNext == true) { */
            this.utilityPoll();
            /*    this.utility.finalNext = false; */
            /*  } */
            this.utility.next = false;
          }
        }, 100);
      }
    },
    searchAddressForGivenNames() {
      for (let index = 0; index < this.dataTableItems.length; index++) {
        this.$set(this.dataTableItems[index], "address", "");
        this.$set(this.dataTableItems[index], "finalAddress", "");
      }

      // Search through data table items
      for (let i = 0; i < this.dataTableItems.length; i++) {
        // For each row, try to find adresses for known names
        for (let j = 0; j < this.variables.name.length; j++) {
          // Variable found in known parsed variables
          if (this.dataTableItems[i].name == this.variables.name[j]) {
            // Reactive way
            // At the same index is our variable
            this.$set(this.dataTableItems[i], "address", this.variables.address[j]);

            // Parse number from string
            // Number contain 0X it means it take automaticaly as hexadecimal
            let address = parseInt(this.dataTableItems[i].address);

            let offset = 0;

            let finalAddress = "";

            if (!isNaN(this.dataTableItems[i].offset) && this.dataTableItems[i].offset != null && this.dataTableItems[i].offset != "") {
              // Set offset only, when offset is valid number
              offset = parseInt(this.dataTableItems[i].offset);
            }

            // Final addres is sum addr with offset
            finalAddress = address + offset;

            // Convert address to hexadecimal and upper case
            finalAddress = "0x00000000" + finalAddress.toString(16).toUpperCase();

            // Finaly set table offset item
            this.$set(this.dataTableItems[i], "offset", offset);
            // Finaly set table finalAddres item
            this.$set(this.dataTableItems[i], "finalAddress", finalAddress);

            break;
          }
          // In case variables was not found, offset and address is set to 0
          if (j == this.variables.name.length - 1) {
            this.$set(this.dataTableItems[i], "address", "0X0000000000000000");
            this.$set(this.dataTableItems[i], "offset", 0);
            this.$set(this.dataTableItems[i], "finalAddress", "0X0000000000000000");
          }
        }
      }
    },
    sendRequestFromCurrentTable(pageIndex) {
      let variables = "";
      let offsetSRAM = "";
      let typeValue = "";

      let addressLen = 0;
      let dbgIs = "";

      if (this.version.memorySize.current == 32) {
        addressLen = 8;
        dbgIs = "DBG:is2:";
      } else if (this.version.memorySize.current == 16) {
        addressLen = 4;
        dbgIs = "DBG:is:";
      }

      // Extract variable offset from base SRAM address
      // Then store it to message with following format
      for (let index = 0; index < this.dataTableItems.length; index++) {
        // Tohle by bylo fajn, akorát embeded potřebuje mít pouze maximálně FFFF nikoliv až
        // Todo v budoucnu předělat na maximální možnou RAM
        /* offsetSRAM = this.dataTableItems[index].finalAddress.substr(
          12,
          this.dataTableItems[index].finalAddress.length
        ); */

        // When address cannot be found, this index must be skipped
        // searchAddressForGivenNames method didnt find address to given name
        if (this.dataTableItems[index].finalAddress == null || this.dataTableItems[index].finalAddress == undefined) {
          continue;
        }

        // Extract 4 last hexa value to get SRAM offset
        offsetSRAM = this.dataTableItems[index].finalAddress.substr(this.dataTableItems[index].finalAddress.length - addressLen, this.dataTableItems[index].finalAddress.length);

        // Get type value for every row
        typeValue = MyVariables.GetTypeValue(this.dataTableItems[index].type);

        // Format
        if (pageIndex.length == 1) {
          pageIndex = "0" + pageIndex;
        }

        // Every variable is stored in buffer
        variables += offsetSRAM + "," + typeValue + ";";
      }

      // Final request for given inspect page
      let request = dbgIs + pageIndex + ";" + variables + "\n";

      this.portWrite(request, false);
    },
    recalculateDataTableId() {
      for (let index = 0; index < this.dataTableItems.length; index++) {
        this.$set(this.dataTableItems[index], "id", index + 1);
      }
    },
    setDataTablePointer(index) {
      for (let i = 0; i < this.dataTableItems.length; i++) {
        this.$set(
          this.dataTableItems[i], //
          "selected", //
          constNotSelected //
        ); //
      }
      this.$set(
        this.dataTableItems[index], //
        "selected", //
        constSelected //
      ); //
    },
    moveUpDataTablePointer() {
      if (this.dataTableItems[0].selected != constSelected) {
        for (let index = 0; index < this.dataTableItems.length; index++) {
          if (this.dataTableItems[index].selected == constSelected) {
            this.$set(
              this.dataTableItems[index], //
              "selected", //
              constNotSelected
            ); //
            this.$set(
              this.dataTableItems[index - 1], //
              "selected", //
              constSelected //
            ); //
            this.dataTableSelectedId = index - 1;
            break;
          }
        }
      }
    },
    moveDownDataTablePointer() {
      if (this.dataTableItems[this.dataTableItems.length - 1].selected != constSelected) {
        for (let index = 0; index < this.dataTableItems.length; index++) {
          if (this.dataTableItems[index].selected == constSelected) {
            this.$set(
              this.dataTableItems[index], //
              "selected", //
              constNotSelected
            ); //
            this.$set(
              this.dataTableItems[index + 1], //
              "selected", //
              constSelected //
            ); //
            this.dataTableSelectedId = index + 1;
            break;
          }
        }
      }
    },
    clearIntervalMaximumMinimum() {
      for (let index = 0; index < this.dataTableItems.length; index++) {
        this.$set(this.dataTableItems[index], "intervalA", this.dataTableItems[index].value);
        this.$set(this.dataTableItems[index], "intervalB", this.dataTableItems[index].value);
      }
    },
    loadInspectPage(page) {
      if (this.detailedLog == true) {
        console.log("loadInspectPage() page:", page);
      }

      if (this.inspectPages[page] === undefined) {
        return;
      }

      // Read selected file, Parse to javascript object
      let inspectPage = JSON.parse(FileSystem.readFileSync(this.inspectPages[page].path));

      if (this.detailedLog == true) {
        console.log(inspectPage);
      }

      if ("variables" in inspectPage) {
        this.dataTableItems = inspectPage.variables;

        this.searchForKeysInGlobalFile();
      }
      if ("controls" in inspectPage) {
        this.dataTableControlItems = inspectPage.controls;

        this.searchForKeysForControlsInGlobalFile();
      }
      if ("background" in inspectPage) {
        this.dataTableBackgroundItems = inspectPage.background;

        if ("image" in this.dataTableBackgroundItems) {
          this.dataTableBackgroundItems.url = "/" + this.dataTableBackgroundItems.image;
        }
      }

      // Store selected page index
      for (let index = 0; index < this.inspectPages.length; index++) {
        if (this.inspectPages[index].name === this.inspectPageSelect) {
          this.inspectPageSelectId = index;
          break;
        }
      }

      this.inspectPageSelect = this.inspectPages[page].name;

      // Get addresses, offsets and finalAddresses for given names (from inspect table)
      this.searchAddressForGivenNames();

      for (let index = 0; index < this.dataTableItems.length; index++) {
        let name;
        //console.log(this.dataTableItems[index].desc);
        if (this.dataTableItems[index].desc == undefined) {
          name = this.dataTableItems[index].name;
        } else {
          name = this.dataTableItems[index].name + "  " + this.dataTableItems[index].desc;
        }

        this.$set(this.dataTableItems[index], "finalName", name);
        this.$set(this.dataTableItems[index], "id", index);
      }

      if (this.dataTableItems.length != 0) {
        this.$set(this.dataTableItems[0], "selected", constSelected);
      }
    },
    addTrigger() {
      let obj = {
        name: "",
        cond: "=",
        value: 0,
        type: "U8",
      };

      this.dataTableTriggersItems.push(obj);
    },
    deleteTrigger(item) {
      let items = this.dataTableTriggersItems;
      for (let index = 0; index < items.length; index++) {
        if (
          item.name == items[index].name && //
          item.cond == items[index].cond && //
          item.value == items[index].value && //
          item.type == items[index].type //
        ) {
          items.splice(index, 1);
          return;
        }
      }
    },
    setTrigger(item) {
      let type = item.type;
      let value = item.value;
      let name = item.name;
      let condition = item.cond;

      let operatorValue = MyTriggers.GetOperatorValue(condition);
      let typeValue = MyVariables.GetTypeValue(type);

      let address = "";
      for (let index = 0; index < this.variables.name.length; index++) {
        if (this.variables.name[index] == name) {
          address = this.variables.address[index];
          break;
        }
        if (index == this.variables.name.length - 1) {
          return;
        }
      }

      if (address.length > 8) {
        address = address.substr(address.length - 8, address.length);
      }

      value = MyMath.Float2Hexa(parseFloat(value));

      /*       if (this.version.ieee754Enabled === true) {
        if (MyVariables.IsTypeFloat(type)) {

        } else if (MyVariables.IsTypeInteger(type)) {
          value = MyMath.Int2Hexa(parseInt(value));
        }
      } else {
        value = MyMath.Int2Hexa(parseInt(value));
      } */

      // Request for trigger
      let request = "DBG:tr:" + address + "," + typeValue + "," + operatorValue + "," + value + "\n";

      this.portWrite(request, false);
    },
    clearTrigger() {
      // Clear trigger
      let request = "DBG:tr:" + "00000000" + "," + "00" + "," + "00" + "," + "00000000" + "\n";

      this.portWrite(request, false);
    },
    searchForKeysForControlsInGlobalFile() {
      for (let i = 0; i < this.dataTableControlItems.length; i++) {
        if ("varkey" in this.dataTableControlItems[i]) {
          for (let j = 0; j < this.ECSVariables.controls.length; j++) {
            if (this.dataTableControlItems[i].varkey === this.ECSVariables.controls[j].key) {
              if (!("offset" in this.dataTableControlItems[i])) {
                if ("offset" in this.ECSVariables.controls[j]) {
                  this.dataTableControlItems[i].offset = this.ECSVariables.controls[j].offset;
                }
              }
              if (!("type" in this.dataTableControlItems[i])) {
                if ("type" in this.ECSVariables.controls[j]) {
                  this.dataTableControlItems[i].type = this.ECSVariables.controls[j].type;
                }
              }
              if (!("value" in this.dataTableControlItems[i])) {
                if ("value" in this.ECSVariables.controls[j]) {
                  this.dataTableControlItems[i].value = this.ECSVariables.controls[j].value;
                }
              }
              if (!("desc" in this.dataTableControlItems[i])) {
                if ("desc" in this.ECSVariables.controls[j]) {
                  this.dataTableControlItems[i].desc = this.ECSVariables.controls[j].desc;
                }
              }
              if (!("style" in this.dataTableControlItems[i])) {
                if ("style" in this.ECSVariables.controls[j]) {
                  this.dataTableControlItems[i].style = this.ECSVariables.controls[j].style;
                }
              }
            }
          }
        } else {
          continue;
        }
      }
    },
    searchForKeysInGlobalFile() {
      for (let i = 0; i < this.dataTableItems.length; i++) {
        if ("varkey" in this.dataTableItems[i]) {
          for (let j = 0; j < this.ECSVariables.variables.length; j++) {
            if (this.dataTableItems[i].varkey === this.ECSVariables.variables[j].key) {
              if (!("offset" in this.dataTableItems[i])) {
                if ("offset" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].offset = this.ECSVariables.variables[j].offset;
                }
              }
              if (!("format" in this.dataTableItems[i])) {
                if ("format" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].format = this.ECSVariables.variables[j].format;
                }
              }
              if (!("type" in this.dataTableItems[i])) {
                if ("type" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].type = this.ECSVariables.variables[j].type;
                }
              }
              if (!("desc" in this.dataTableItems[i])) {
                if ("desc" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].desc = this.ECSVariables.variables[j].desc;
                }
              }
              if (!("units" in this.dataTableItems[i])) {
                if ("units" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].units = this.ECSVariables.variables[j].units;
                }
              }
              if (!("gain" in this.dataTableItems[i])) {
                if ("gain" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].gain = this.ECSVariables.variables[j].gain;
                }
              }
              if (!("style" in this.dataTableItems[i])) {
                if ("style" in this.ECSVariables.variables[j]) {
                  this.dataTableItems[i].style = this.ECSVariables.variables[j].style;
                }
              }
            }
          }
        } else {
          continue;
        }
      }
    },
    setInspectPage(edit) {
      this.inspectPageHasBeenChanged = true;

      this.dataTableSelected = [];

      this.dataTableSelectedId = 0;

      if (edit == false) {
        this.dataTableItems = [];
        this.dataTableControlItems = [];
        this.dataTableBackgroundItems = [];
      }

      /*       this.inspectPages[this.inspectPageSelectId].path */

      /*             // Store selected page index
      for (let index = 0; index < this.inspectPages.length; index++) {
        if (this.inspectPages[index].name === this.inspectPageSelect) {
          this.inspectPageSelectId = index;
          break;
        }
      } */

      if (this.detailedLog == true) {
        console.log("setInspectPage() inspectPageSelect: ", this.inspectPageSelect);
      }

      // Validate
      if (this.inspectPageSelect == null) {
        return;
      }

      if (edit == false) {
        // Get object 'path' based on selected name
        let inspectPageObj = this.inspectPages.find((obj) => obj.name === this.inspectPageSelect);

        // Store selected page index
        for (let index = 0; index < this.inspectPages.length; index++) {
          if (this.inspectPages[index].name === this.inspectPageSelect) {
            this.inspectPageSelectId = index;
            break;
          }
        }

        if (this.detailedLog == true) {
          console.log(inspectPageObj.path);
        }

        // Read selected file, Parse to javascript object
        let l = JSON.parse(FileSystem.readFileSync(inspectPageObj.path));

        if (this.detailedLog == true) {
          console.log(l);
        }

        if ("variables" in l) {
          this.dataTableItems = l.variables;

          this.searchForKeysInGlobalFile();
        }
        if ("controls" in l) {
          this.dataTableControlItems = l.controls;

          this.searchForKeysForControlsInGlobalFile();
        }
        if ("background" in l) {
          this.dataTableBackgroundItems = l.background;

          if ("image" in this.dataTableBackgroundItems) {
            this.dataTableBackgroundItems.url = "/" + this.dataTableBackgroundItems.image;
          }
        }
      } else {
        this.setDataTablePointer(0);
      }

      // Get addresses, offsets and finalAddresses for given names (from inspect table)
      this.searchAddressForGivenNames();

      for (let index = 0; index < this.dataTableItems.length; index++) {
        let name;
        //console.log(this.dataTableItems[index].desc);
        if (this.dataTableItems[index].desc == undefined) {
          name = this.dataTableItems[index].name;
        } else {
          name = this.dataTableItems[index].name + "  " + this.dataTableItems[index].desc;
        }

        this.$set(this.dataTableItems[index], "finalName", name);
        this.$set(this.dataTableItems[index], "id", index);
      }

      if (this.dataTableItems.length != 0) {
        if (edit == false) {
          this.$set(this.dataTableItems[0], "selected", constSelected);
        }
      }

      let pageIndex = this.inspectPages
        .findIndex((data) => data.name === this.inspectPageSelect)
        .toString(16)
        .toUpperCase();

      console.log(pageIndex);

      this.sendRequestFromCurrentTable(pageIndex);

      setTimeout(() => {
        this.inspectPageHasBeenChanged = false;
      }, 2000);
    },
    onFileChange() {
      if (this.file == null) {
        this.outputMap = null;
        this.parsedMap = null;
        return;
      }

      console.log(this.file);

      this.readMapFile(this.file);
    },
    readMapFile(file) {
      let reader = new FileReader();
      reader.onload = (event) => {
        this.fileInputLabel = "";
        this.parseMap(event.target.result);
        this.searchAddressForGivenNames();

        /* let json = JSON.parse(e.target.result); */
        //console.log(event.target.result);
      };
      reader.readAsText(file);
    },
    reloadFolders() {
      this.filesPaths = [];
      this.files = [];

      this.scanDirectory("./", ".json");
      this.scanDirectory("./", ".map");

      this.snackbarInfo = true;
      this.snackbarInfoText = this.$i18n.t("service.snackbar.foldersLoaded") + "\n";

      this.filesPath = this.filesPaths[0];

      this.changeProjectPointer();
    },
    reloadMap() {
      if (this.file != null) {
        if (this.file.path.length != 0) {
          console.log(this.file.path);
          const mapFile = FileSystem.readFileSync(this.file.path, "utf8");

          this.parseMap(mapFile);
          this.searchAddressForGivenNames();

          this.snackbarInfo = true;
          this.snackbarInfoText = this.$i18n.t("service.snackbar.mapLoaded") + "\n";
        }
      } else if (this.fileInputLabel.length != 0) {
        const pathMap = FilePath.resolve("users", "..", this.fileInputLabel);
        console.log(pathMap);
        const mapFile = FileSystem.readFileSync(pathMap, "utf8");

        this.parseMap(mapFile);
        this.searchAddressForGivenNames();

        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.mapLoaded") + "\n";
      } else {
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.mapNotLoaded") + "\n";
      }
    },
    changeProjectPointer() {
      this.snackbarInfoText = "";

      let path = "./" + this.filesPath;

      console.log("changeProjectPointer() " + path);

      this.inspectPages = [];

      this.baudrateOverwriten = false;
      this.mapFound = false;

      this.scanDirectoryAndParseFiles(path, ".json");
      this.scanDirectoryAndParseFiles(path, ".map");

      // No custom config was found, we set default baudrate defined in ECSConfig.json
      if (this.baudrateOverwriten == false) {
        this.snackbarInfo = true;

        this.snackbarInfoText += this.$i18n.t("service.snackbar.customConfigFound") + "\n";
        this.snackbarInfoText += this.$i18n.t("service.snackbar.customBaudrate") + this.config.baudrate + " [Bd/s] \n";

        setTimeout(() => {
          this.setPort(null);

          this.serialSettings.baudRate = this.config.baudrate;

          setTimeout(() => {
            this.setPort(this.config.port);
          }, 1000);
        }, 1250);
      }

      if (this.mapFound == false) {
        this.snackbarInfo = true;
        this.snackbarInfoText += this.$i18n.t("service.snackbar.mapNotFound") + "\n";
        this.variables = {
          address: [],
          name: [],
        };
        this.fileInputLabel = "";
      } else {
        this.snackbarInfo = true;
        this.snackbarInfoText += this.$i18n.t("service.snackbar.mapFound") + "\n";
      }

      if (this.inspectPages.length != 0) {
        this.snackbarInfo = true;
        this.snackbarInfoText += this.$i18n.t("service.snackbar.inspectPageFound") + "\n";
      } else {
        this.snackbarInfo = true;
        this.snackbarInfoText += this.$i18n.t("service.snackbar.inspectPageNotFound") + "\n";
      }

      this.openEveryFileAndParseName();
    },
    setDefaultMap() {
      let path;
      let saveObject;

      if (this.file != null) {
        if (this.file.path.length != 0) {
          path = this.file.path;
        }
      } else if (this.fileInputLabel.length != 0) {
        const pathMap = FilePath.resolve("users", "..", this.fileInputLabel);
        path = pathMap;
      } else {
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.savedAsDefaultFailed") + "\n";
        return;
      }

      this.config.map = path;

      try {
        saveObject = JSON.stringify(this.config, null, "\t");

        FileSystem.writeFileSync(FilePath.resolve("users", "..", "ECSConfig.json"), saveObject);
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.savedAsDefault") + "\n";
      } catch (error) {
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.savedAsDefaultFailed") + "\n";
        this.snackbarInfoText += err + "\n";
        console.error(err);
      }
    },
    setDefaultRelease() {
      let saveObject;
      this.config.release = this.filesPath;

      try {
        saveObject = JSON.stringify(this.config, null, "\t");

        FileSystem.writeFileSync(FilePath.resolve("users", "..", "ECSConfig.json"), saveObject);
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.savedAsDefault") + "\n";
      } catch (err) {
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$i18n.t("service.snackbar.savedAsDefaultFailed") + "\n";
        this.snackbarInfoText += err + "\n";
        console.error(err);
      }
    },
    parseFiles(fileNameFullPath) {
      let fileObj = {};

      let fileName;
      let fileExtension;

      if (fileNameFullPath.includes("inspect") && fileNameFullPath.includes(".json")) {
        fileName = fileNameFullPath.substr(
          this.filesPath.length, //
          fileNameFullPath.length - this.filesPath.length - 5 //
        );

        fileExtension = fileNameFullPath.substr(
          fileNameFullPath.length - 5, //
          fileNameFullPath.length //
        );

        fileObj = {
          path: fileNameFullPath,
          name: fileName + fileExtension,
        };

        console.log(fileObj);

        this.inspectPages.push(fileObj);
      }
      if (fileNameFullPath.includes(".map")) {
        try {
          const mapFile = FileSystem.readFileSync(fileNameFullPath, {
            encoding: "utf8",
            flag: "r",
          });
          this.parseMap(mapFile);
          this.searchAddressForGivenNames();
          this.fileInputLabel = fileNameFullPath;
          this.mapFound = true;
        } catch (error) {
          console.log(error);
          console.log(fileNameFullPath);
        }
      }
      if (fileNameFullPath.includes("customConfig") && fileNameFullPath.includes(".json")) {
        try {
          let x = JSON.parse(FileSystem.readFileSync(fileNameFullPath));
          this.snackbarInfo = true;
          this.snackbarInfoText += this.$i18n.t("service.snackbar.customConfigFound") + "\n";

          if ("baudrate" in x) {
            this.baudrateOverwriten = true;

            this.setPort(null);

            this.snackbarInfoText += this.$i18n.t("service.snackbar.baudrate") + x.baudrate + " [Bd/s] \n";
            this.serialSettings.baudRate = x.baudrate;
            setTimeout(() => {
              this.setPort(this.config.port);
            }, 1000);
          }
        } catch (error) {
          console.log(error);
          console.log(fileNameFullPath);
        }
      }
      if (fileNameFullPath.includes("variables-vals") && fileNameFullPath.includes(".json")) {
        try {
          this.variablesVals = JSON.parse(FileSystem.readFileSync(fileNameFullPath));
        } catch (error) {
          console.log(error);
          console.log(fileNameFullPath);
        }
      }
      if (fileNameFullPath.includes("recorder") && fileNameFullPath.includes(".json")) {
        try {
          this.recorderJSON = JSON.parse(FileSystem.readFileSync(fileNameFullPath));
        } catch (error) {
          console.log(error);
          console.log(fileNameFullPath);
        }
      }
      if (fileNameFullPath.includes("trigers") && fileNameFullPath.includes(".json")) {
        this.triggerJSON = {
          path: fileNameFullPath,
        };
        try {
          this.dataTableTriggersItems = JSON.parse(FileSystem.readFileSync(fileNameFullPath));
        } catch (error) {
          console.log(error);
          console.log(fileNameFullPath);
        }
      }
    },
    scanDirectoryAndParseFiles(startPath, filter) {
      if (!FileSystem.existsSync(startPath)) {
        console.log("No directory found", startPath);
        return;
      }

      let files = FileSystem.readdirSync(startPath);

      for (let i = 0; i < files.length; i++) {
        let fileNameFullPath = FilePath.join(startPath, files[i]);
        let stat = FileSystem.lstatSync(fileNameFullPath);

        // Is it directory ?
        if (stat.isDirectory()) {
          // Is it symlink ?
        } else if (stat.isSymbolicLink()) {
          if (fileNameFullPath.lastIndexOf(filter) >= 0) {
            // Filtered file
            this.parseFiles(fileNameFullPath);
          } else if (fileNameFullPath.includes(".")) {
            // Not interested file
          } else {
            // Folder
          }
          // Is it filtered file?
        } else if (fileNameFullPath.lastIndexOf(filter) >= 0) {
          this.parseFiles(fileNameFullPath);
        }
      }
    },
    scanDirectory(startPath, filter) {
      if (!FileSystem.existsSync(startPath)) {
        console.log("No directory found", startPath);
        return;
      }

      console.warn("\t\t\t\t\t\t\t\t" + startPath + "/*" + filter);

      let files = FileSystem.readdirSync(startPath);

      this.inspectPage = [];

      for (let i = 0; i < files.length; i++) {
        let fileNameFullPath = FilePath.join(startPath, files[i]);
        let stat = FileSystem.lstatSync(fileNameFullPath);

        if (
          fileNameFullPath.includes(".git") || //
          fileNameFullPath.includes("android") || //
          fileNameFullPath.includes("ios") || //
          fileNameFullPath.includes("node_modules") || //
          fileNameFullPath.includes("dist_electron") || //
          fileNameFullPath.includes("dist")
        ) {
          continue;
        }

        if (stat.isDirectory()) {
          console.warn("Folder: \t\t\t\t\t\t" + fileNameFullPath);
          this.scanDirectory(fileNameFullPath, filter);
        } else if (stat.isSymbolicLink()) {
          if (fileNameFullPath.lastIndexOf(filter) >= 0) {
            this.files.push(fileNameFullPath);
            this.filesPaths.push(fileNameFullPath.substr(0, fileNameFullPath.lastIndexOf("/")));
            let counter = 0;
            for (let index = 0; index < this.filesPaths.length; index++) {
              if (this.filesPaths[index] == fileNameFullPath) {
                counter++;
              }
              if (counter == 2) {
                this.filesPaths.splice(index, 1);
                counter--;
              }
            }
            console.warn("SymLink - File:  \t\t\t\t" + fileNameFullPath);
          } else if (fileNameFullPath.includes(".")) {
            console.warn("SymLink - FileNotInterested: \t" + fileNameFullPath);
          } else {
            console.warn("SymLink - Folder: \t\t\t" + fileNameFullPath);
            this.scanDirectory(fileNameFullPath, filter);
          }
        } else if (fileNameFullPath.lastIndexOf(filter) >= 0) {
          this.files.push(fileNameFullPath);
          this.filesPaths.push(fileNameFullPath.substr(0, fileNameFullPath.lastIndexOf("/")));

          let counter = 0;
          for (let index = 0; index < this.filesPaths.length; index++) {
            if (this.filesPaths[index] == fileNameFullPath) {
              counter++;
            }
            if (counter == 2) {
              this.filesPaths.splice(index, 1);
              counter--;
            }
          }

          console.warn("File: \t\t\t\t\t\t" + fileNameFullPath);
        }
      }

      //console.warn(this.filesPaths);
    },
    openEveryFileAndParseName() {
      let parsedFile;

      let title;
      let name;

      for (let index = 0; index < this.inspectPages.length; index++) {
        try {
          /*           console.log(this.inspectPages[index].path);
          console.log(FileSystem.readFileSync(this.inspectPages[index].path)); */

          parsedFile = JSON.parse(FileSystem.readFileSync(this.inspectPages[index].path));

          title = parsedFile.title;
          name = this.inspectPages[index].name.toString();

          if (title == undefined) {
            title = "";
          }
          if (name == undefined) {
            name = "";
          }

          console.log("title " + title);
          this.$set(this.inspectPages[index], "title", title);

          if (title.length > 100) {
            title = title.substr(0, 100) + "...";
          }
          if (name.length > 20) {
            name = name.substr(0, 20) + "...";
          }

          console.log(name + title);

          this.$set(this.inspectPages[index], "finalName", name + " " + title);
        } catch (error) {
          console.log(error);
          console.log("Error at openEveryFileAndParseName() path:", this.inspectPages[index].path);
        }
      }
    },
    closeActivePort() {
      if (Port != null) {
        if (Port.isOpen) {
          Port.close((error) => {
            console.log("Closing port");
            this.timer.watchdog.enabled = false;
            if (error != null) {
              console.log("Error during closing port: ", error);
            }
          });
        }
      }
    },
    setPort(value) {
      console.log("setPort(value)", value);

      let path = null;
      //let valueIsInKnownPorts = false;

      // Check if it's open port
      if (Port != null) {
        // Close active port, cause we opening a new one .)
        this.closeActivePort();
      }

      Port = null;

      if (value === "" || value === null) {
        /* this.port = null; */
        console.log("setPort() Invalid");
        return;
      } else {
        path = value.substr(0, value.search(" "));

        if (path == null || path == "") {
          path = value.substr(0, value.length);
        }
      }

      if (this.detailedLog == true) {
        console.log("value", value);
        console.log("path", path);
        console.log("this.paths", this.paths);
        console.log("this.ports", this.ports);
        console.log("this.portsObj", this.portsObj);
      }

      if (Port == null) {
        try {
          Port = new SerialPort({
            path,
            baudRate: parseInt(this.serialSettings.baudRate),
            dataBits: parseInt(this.serialSettings.dataBits),
            stopBits: parseInt(this.serialSettings.stopBits),
            parity: this.serialSettings.parity,
            autoOpen: false,
          });

          Parser = Port.pipe(new ReadlineParser({ delimiter: "\n" }));

          this.timer.watchdog.enabled = true;

          if (this.timer.watchdog.set == null) {
            this.timer.watchdog.set = setInterval(() => {
              if (this.timer.watchdog.enabled === true) {
                this.watchdogCounter += 0.1;

                if (this.watchdogCounter > this.watchdogCounterMax) {
                  this.timer.watchdog.enabled = false;

                  this.portWrite(this.requestLast);

                  if (this.watchdogCounterRepeat < 3) {
                    this.watchdogCounterRepeat++;
                    Port.pause();
                    Port.resume();
                  } else {
                    // Reconnect

                    this.lastUSBPath = this.port;

                    if (Port != null) {
                      this.closeActivePort();
                    }

                    setTimeout(() => {
                      if (Port.isOpen == false) {
                        Port = null;
                        Parser = null;
                        this.setPort(this.lastUSBPath);

                        this.watchdogCounterRepeat = 0;
                      }
                    }, 1000);
                  }

                  this.timer.watchdog.enabled = true;

                  this.watchdogTotalReconnects++;

                  this.watchdogCounter = 0;

                  if (false) {
                    this.timer.watchdog.enabled = false;

                    this.lastUSBPath = this.port;

                    setTimeout(() => {
                      if (Port != null) {
                        this.closeActivePort();
                      }

                      Port = null;

                      setTimeout(() => {
                        this.setPort(this.lastUSBPath);
                        this.lastUSBPath = "";
                      }, 1000);
                    }, 1000);

                    this.timer.watchdog.enabled = true;

                    this.watchdogTotalReconnects++;

                    this.watchdogCounter = 0;
                  }
                }
              }
            }, this.timer.watchdog.period);
          }

          Parser.on("data", this.processRxMessage);

          // Buffer offset 33027
          // Buffer offset 32938
          // Buffer offset 32945

          Port.open(() => {
            console.log("setPort() Port is open");
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    getData() {
      if (Port == null || Port.isOpen == false || this.chartIsLoading == true) {
        return;
      }

      if (this.version.inspectRequestWithEDCEnabled === true) {
        let request = "DBG:rq1\n";

        this.portWrite(request, true);
      } else {
        let request = "DBG:rq\n";

        this.portWrite(request, true);
      }
    },
    getChart() {
      this.timer.portWrite.enabled = false;

      if (Port == null || Port.isOpen == false) {
        return;
      }

      if (this.version.chartRequestWithEDCEnabled === true) {
        let request = "DBG:sh\n";

        this.portWrite(request, true);
      } else {
        let request = "DBG:rd\n";
        this.portWrite(request, true);
      }

      this.chartIsLoading = true;
      this.rdRenderEN[this.tabsRecorder.length - 1] = true;

      if (this.version.chartRequestWithEDCEnabled === false) {
        setTimeout(() => {
          this.rdRenderEN[this.tabsRecorder.length - 1] = false;
          this.chartIsLoading = false;

          this.timer.portWrite.enabled = true;
        }, 15000);
      } else {
        setTimeout(() => {
          this.rdRenderEN[this.tabsRecorder.length - 1] = false;
          this.chartIsLoading = false;

          this.timer.portWrite.enabled = true;
        }, 15000);
      }
    },
    recalculateRealtimeChartGain(item) {
      for (let i = 0; i < this.rt.length; i++) {
        if (this.rt[i].index == item.index) {
          for (let j = 0; j < this.rt[i].dataRaw.length; j++) {
            this.rt[i].data[j] = this.rt[i].dataRaw[j] * this.rt[i].gain;
          }
        }
      }
    },
    makeSample() {
      for (let index = 0; index < this.rt.length; index++) {
        if (this.rt[index].dataRaw.length < this.samples.max) {
          this.rt[index].dataRaw.push(this.dataTableItems[this.rt[index].index].value);
          this.rt[index].data.push(this.dataTableItems[this.rt[index].index].value * this.rt[index].gain);
        } else {
          this.rt[index].dataRaw.shift();
          this.rt[index].dataRaw.push(this.dataTableItems[this.rt[index].index].value);
          this.rt[index].data.shift();
          this.rt[index].data.push(this.dataTableItems[this.rt[index].index].value * this.rt[index].gain);
        }
      }
    },

    addTabs(type) {
      if (type == "Recorder") {
        if (this.tabsRecorder.length < constMaximumRecorderCharts) {
          this.tabsRecorder.length++;
        } else {
          return;
        }
        this.getChart();
        this.tabsRecorder[this.tabsRecorder.length - 1] = "Recorder " + this.tabsRecorder.length;

        setTimeout(() => {
          this.tabs = constStaticTabs + this.tabsRecorder.length - 1;
        }, 1000);
      } else if (type == "Chart") {
        if (this.tabsChart.length < constMaximumRealtimeCharts) {
          this.tabsChart.length++;
        } else {
          return;
        }

        this.timer.variableSample.enabled = true;

        this.timer.variableSample.set = setInterval(() => {
          if (this.timer.variableSample.enabled === true) {
            this.makeSample();
          }
        }, this.timer.variableSample.period * 1000);

        this.setRealTimeChart();
        this.tabsChart[this.tabsChart.length - 1] = "Chart " + this.tabsChart.length;

        setTimeout(() => {
          this.tabs = constStaticTabs + this.tabsRecorder.length + this.tabsChart.length - 1;
        }, 1000);
      }
    },
    deleteTabs(index, type) {
      if (this.chartIsLoading == false) {
        if (type == "Recorder") {
          if (this.tabsRecorder.length > 0) {
            this.tabsRecorder.splice(index, 1);
            this.rd.splice(index, 1);
          }
        } else if (type == "Chart") {
          //
          if (this.timer.variableSample.set != null) {
            clearInterval(this.timer.variableSample.set);
          }
          //
          if (this.tabsChart.length > 0) {
            this.tabsChart.splice(index, 1);
            this.rt.splice(index, 1);
          }
        }
      }
    },
    getVariablesAndValuesDescription() {
      // For every items in variables-vals
      for (let i = 0; i < this.variablesVals.length; i++) {
        // For every items in datatable
        for (let j = 0; j < this.dataTableItems.length; j++) {
          // Names are being compared
          if (this.variablesVals[i].var == this.dataTableItems[j].name) {
            // When name is found
            // When codealias exist, description is searched in varible-desc
            if ("codealias" in this.variablesVals[i]) {
              // Offset is defined, it's nessesary to respect that
              if ("offset" in this.variablesVals[i]) {
                if (this.variablesVals[i].offset == this.dataTableItems[j].offset) {
                  // For every items in variables-vals
                  for (let k = 0; k < this.variablesDesc.length; k++) {
                    if (this.variablesVals[i].codealias == this.variablesDesc[k].code) {
                      // Variable-Desc is used with offset
                      this.getAndSetDescriptionAndIntervals(this.variablesDesc[k], this.dataTableItems[j]);
                    }
                  }
                }
              } else {
                // No offset is defined
                // For every items in variables-vals
                for (let k = 0; k < this.variablesDesc.length; k++) {
                  if (this.variablesVals[i].codealias == this.variablesDesc[k].code) {
                    // Variable-Desc is used without offset
                    this.getAndSetDescriptionAndIntervals(this.variablesDesc[k], this.dataTableItems[j]);
                  }
                }
              }
            } else {
              // No codealias exist, description is searched in variable-vals
              // Offset is defined, it's nessesary to respect that
              if ("offset" in this.variablesVals[i]) {
                if (this.variablesVals[i].offset == this.dataTableItems[j].offset) {
                  if ("vals" in this.variablesVals[i]) {
                    // Variable-Vals is used with offset
                    this.getAndSetDescriptionAndIntervals(this.variablesVals[i], this.dataTableItems[j]);
                  }
                }
              } else {
                // No offset is defined
                if ("vals" in this.variablesVals[i]) {
                  // Variable-Vals is used without offset
                  this.getAndSetDescriptionAndIntervals(this.variablesVals[i], this.dataTableItems[j]);
                }
              }
            }
          }
        }
      }
    },
    getAndSetDescriptionAndIntervals(searchObj, targetObj) {
      let bitInit = 0;

      targetObj.bits = [];

      let bitsObj = {};

      let bitLevel;

      let bit = 0;
      let bitDesc = "";

      // Loop through vals
      for (let index = 0; index < searchObj.vals.length; index++) {
        // For given index, let's check if bit and desc node exist (status)
        if ("bit" in searchObj.vals[index] && "desc" in searchObj.vals[index]) {
          // First time bits init
          if (bitInit === 0) {
            for (let j = 0; j < constBitDescLen; j++) {
              bitsObj = {
                index: j,
                value: 0,
                desc: "ReservedBit" + j,
              };
              targetObj.bits.push(bitsObj);
            }
            // Do it only once per loop
            bitInit = 1;
          }

          this.$set(targetObj, "intervalsDesc", true);

          if (index == 0) {
            this.$set(targetObj, "intervals", "");
          }

          bit = searchObj.vals[index].bit;
          bitDesc = searchObj.vals[index].desc;

          // Decimal to binary conversion
          if ((targetObj.value & (1 << bit)) != 0) {
            bitLevel = 1;

            // Cosmetic;
            if (targetObj.intervals.length == 0) {
              this.$set(targetObj, "intervals", " | ");
            }

            // Active bits description
            targetObj.intervals += bitDesc + " | ";
          } else {
            bitLevel = 0;
          }

          this.$set(targetObj.bits[bit], "value", bitLevel);
          this.$set(targetObj.bits[bit], "desc", bitDesc);

          // When some bits are sets
          if (targetObj.value != 0) {
            // And it's the last index
            if (index == searchObj.vals.length - 1) {
              // And still no text were decoded
              if (targetObj.intervals.length == 0) {
                // That means that descriptions are missing
                this.$set(targetObj, "intervals", "Missing descriptions!");
              }
            }
          }
        }
        // For given index, let's check if eq node exist and desc node exist (state)
        else if ("eq" in searchObj.vals[index] && "desc" in searchObj.vals[index]) {
          // Compare values, if match then state description is found
          if (searchObj.vals[index].eq == targetObj.value) {
            this.$set(targetObj, "intervalsDesc", true);
            this.$set(targetObj, "intervals", searchObj.vals[index].desc);
            this.$set(targetObj, "desc", searchObj.var);
          }
        }
      }
    },
    /* processRecorderChart("init", data.sh.variables, NULL); */
    /* processRecorderChart("run", NULL, data.sb.data); */
    processRecorderChart(state, addrs, data) {
      var lastIndex = this.rd.length < 1 ? 0 : this.rd.length - 1;

      /* console.log(lastIndex); */

      if (state === "init") {
        this.chart = [];

        // Create datasets with addresses & empty data,
        for (let index = 0; index < addrs.length; index++) {
          let obj = {
            name: addrs[index],
            gain: 1,
            data: [],
          };

          this.chart.push(obj);
        }

        // Address is corrected based on the architecture
        for (let i = 0; i < this.chart.length; i++) {
          if (this.architecture === 64) {
            this.chart[i].name = "0X00000000" + this.chart[i].name;
          } else if (this.architecture === 32) {
            this.chart[i].name = "0X" + this.chart[i].name;
          } else {
            this.chart[i].name = "0X" + this.chart[i].name;
          }
        }

        for (let i = 0; i < this.chart.length; i++) {
          for (let j = 0; j < this.variables.name.length; j++) {
            // When address is found, name is also known (at the same index)
            if (this.chart[i].name == this.variables.address[j]) {
              this.chart[i].name = this.variables.name[j];

              let gain;

              // Check if found variable have defined gain in recorder.json file
              for (let k = 0; k < this.recorderJSON.variables.length; k++) {
                if (this.recorderJSON.variables[k].name == this.chart[i].name) {
                  gain = this.recorderJSON.variables[k].gain;

                  if (gain != 0 && gain != 1 && gain != null) {
                    this.chart[i].name += "(x" + gain + ")";
                    this.chart[i].gain = gain;
                  }
                }
              }

              break;
            }
            // In case of no match, not found flag is added to address
            if (j == this.variables.name.length - 1) {
              this.chart[i].name = this.chart[i].name + " not found";
            }
          }
        }
        this.rd.push(this.chart);
      } else if (state === "run") {
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < this.rd[lastIndex].length; j++) {
            this.rd[lastIndex][j].data.push(data[i][j]);
          }
        }
      } else if (state == "end") {
        for (let i = 0; i < this.rd[lastIndex].length; i++) {
          /* this.XXX += " " + "i:" + i + "g:" + this.rd[lastIndex][i].gain + " "; */
          if (this.rd[lastIndex][i].gain != 1) {
            for (let l = 0; l < this.rd[lastIndex][i].data.length; l++) {
              this.$set(this.rd[lastIndex][i].data, l, Math.round(this.rd[lastIndex][i].data[l] * this.rd[lastIndex][i].gain * 1000) / 1000);
            }
          }
        }
      }
    },
    processRxMessage(data) {
      /*       this.xxx = Port;
      this.yyy = ReadlineParser;
      this.zzz = SerialPort; */

      this.timer.portWrite.enabled = false;

      this.watchdogCounter = 0;
      this.watchdogCounterRepeat = 0;

      Port.resume();

      if (this.detailedLog == true) {
        console.log(data);
      }

      if (this.version.inspectRequestWithEDCEnabled === true && this.version.chartRequestWithEDCEnabled === true) {
        data += "\n";

        let indexHash = data.search("#");

        let headerLen = data.substring(indexHash + 1, indexHash + 7);
        let headerChecksum = data.substring(indexHash + 8, indexHash + 11);

        let message = data.substring(indexHash + 12, data.length);

        this.checkSumTransmitedData = parseInt(headerChecksum).toString(16);
        this.checkSumRecivedData = MyMath.CheckSumXOR(message).toString(16);

        while (this.checkSumTransmitedData.length < 3) {
          this.checkSumTransmitedData = "0" + this.checkSumTransmitedData;
        }

        while (this.checkSumRecivedData.length < 3) {
          this.checkSumRecivedData = "0" + this.checkSumRecivedData;
        }

        if (this.errorMessagesCounter === -1) {
          this.errorMessagesCounter = 0;
        }

        if (this.checkSumRecivedData != this.checkSumTransmitedData) {
          this.errorMessagesCounter = this.errorMessagesCounter + 1;
          return;
        }
      } else {
        this.checkSumRecivedData = -1;
        this.checkSumTransmitedData = -1;
        this.errorMessagesCounter = -1;
      }

      try {
        this.snackbarError = false;
        this.snackbarErrorText = "";

        if (this.detailedLog == true) {
          console.log(data);
        }

        // Let's find the begining of the JSON
        if (this.version.inspectRequestWithEDCEnabled === true || this.version.chartRequestWithEDCEnabled === true) {
          data = JSON.parse(data.substr(data.search("#") + 12, data.length));
        } else {
          data = JSON.parse(data.substr(data.search("#") + 8, data.length));
        }

        // Valid message print
        if (constDebugMode === true) {
          console.log(data);
        }
      } catch (error) {
        // In case of invalid JSON structure, error is printed

        /* this.testBBB = data; */

        if (data.length > 40) {
          data = "Unexpected / Neočekávaná data: " + data.substring(0, 40) + "...";
        }

        this.snackbarError = true;
        this.snackbarErrorText = data;
        console.log(data);
        console.log(error);
        return;
      }

      if (this.comm >= 100) {
        if (this.commDelay < 3) {
          this.commDelay++;
        } else {
          this.comm = 0;
          this.commDelay = 3;
        }
      } else {
        if (this.commDelay > 0) {
          this.commDelay--;
        } else {
          this.comm += 15;
        }
      }

      // Simple parser
      // Inspect
      if ("inspect" in data) {
        this.inspect = data.inspect;

        // Inspekt
        if (this.tabs == 0) {
        } else if (this.tabs == 1) {
          if (this.utility.start == true) {
            if ("value" in this.utility.array[0]) {
              let position = this.inspect.page * 20;
              let start = position - 20;
              let end = position;
              if (end > this.utility.array.length) {
                end = this.utility.array.length;
              }

              let j = 0;
              let value = 0;

              for (let i = start; i < end; i++) {
                value = this.inspect.values[j];
                switch (this.utility.type) {
                  case "I8":
                    if (value > 0x7f) value -= 0x100;
                    break;
                  case "I16":
                    if (value > 0x7fff) value -= 0x10000;
                    break;
                  case "I32":
                    if (value > 0x7fffffff) value -= 0x100000000;
                    break;
                  default:
                    break;
                }

                /*
                obj = {
                  address: this.utility.array[i].address
                  value: this.utility.array[i].value
                  index: this.utility.array[i].index
                }
                */
                if (this.utility.array[i] != undefined) {
                  this.$set(this.utility.array[i], "value", value);
                }

                j++;
              }

              /*               if (this.utility.next == true) {
                this.utility.finalNext = true;
              } */

              this.utility.next = true;
              return;
            }
          }
        }

        /*         console.log("page", data.inspect.page);
        console.log("selectedId", this.inspectPageSelectId); */

        if (this.inspectPageSelectId == null) {
          this.loadInspectPage(data.inspect.page);
        }

        if (this.inspectPageHasBeenChanged == false) {
          if (this.inspectPageSelectId != data.inspect.page) {
            this.loadInspectPage(data.inspect.page);
          }
        }

        let value;
        let unit;
        let type;
        let gain;

        // For every items in data table
        // Value is formatted, based on type
        // Intervals are calculated
        for (let index = 0; index < this.dataTableItems.length; index++) {
          type = this.dataTableItems[index].type;

          value = this.inspect.values[index];

          if (this.version.ieee754Enabled === false) {
            switch (type) {
              case "I8":
                if (value > 0x7f) value -= 0x100;
                break;
              case "I16":
                if (value > 0x7fff) value -= 0x10000;
                break;
              case "I32":
              case "F0":
              case "F1":
              case "F2":
              case "F3":
              case "F6":
                if (value > 0x7fffffff) value -= 0x100000000;
                break;
              default:
                break;
            }

            switch (type) {
              case "I8":
              case "U8":
              case "I16":
              case "U16":
              case "I32":
              case "U32":
              case "F0":
                if ("gain" in this.dataTableItems[index]) {
                  gain = this.dataTableItems[index].gain;
                } else {
                  gain = 1;
                }

                let finalRound = 1 / gain;

                value = Math.round(value * gain * finalRound) / finalRound;

                //value = Math.round(value);
                break;
              case "F1":
                value /= 10;
                value = Math.round(value * 10) / 10;
                break;
              case "F2":
                value /= 100;
                value = Math.round(value * 100) / 100;
                break;
              case "F3":
                value /= 1000;
                value = Math.round(value * 1000) / 1000;
                break;
              case "F6":
                value /= 1000000;
                value = Math.round(value * 1000000) / 1000000;
                break;
              default:
                break;
            }
          } else {
            switch (type) {
              case "I8":
                if (value > 0x7f) value -= 0x100;
                break;
              case "I16":
                if (value > 0x7fff) value -= 0x10000;
                break;
              case "I32":
                if (value > 0x7fffffff) value -= 0x100000000;
                break;
              default:
                break;
            }

            if ("gain" in this.dataTableItems[index]) {
              gain = this.dataTableItems[index].gain;

              if (gain != 0 && gain != 1) {
                let finalRound = 1 / gain;

                value = Math.round(value * gain * finalRound) / finalRound;
              }
            }
          }

          // For the first time, init to 0 is needed
          // Cause this member is undefined
          if (this.dataTableItems[index].intervalA == undefined) {
            this.$set(this.dataTableItems[index], "intervalA", 0);
          }
          // For the first time, init to 0 is needed
          // Cause this member is undefined
          if (this.dataTableItems[index].intervalB == undefined) {
            this.$set(this.dataTableItems[index], "intervalB", 0);
          }

          // Min value
          if (value < this.dataTableItems[index].intervalA) {
            this.$set(this.dataTableItems[index], "intervalA", value);
          }
          // Max value
          if (value > this.dataTableItems[index].intervalB) {
            this.$set(this.dataTableItems[index], "intervalB", value);
          }
          // < MinValue; MaxValue >
          this.$set(
            this.dataTableItems[index], //
            "intervals", //
            "<" + //
              this.dataTableItems[index].intervalA.toString() + //
              " ; " + //
              this.dataTableItems[index].intervalB.toString() + //
              ">" //
          ); //

          // Value
          this.$set(this.dataTableItems[index], "value", value);
        }

        this.getVariablesAndValuesDescription();

        let formatedValue;
        let format;
        let finalValue;

        for (let i = 0; i < this.dataTableItems.length; i++) {
          unit = this.dataTableItems[i].units;
          value = this.dataTableItems[i].value;
          format = this.dataTableItems[i].format;

          formatedValue = value;

          if ("format" in this.dataTableItems[i]) {
            switch (format) {
              case "b":
                formatedValue = value.toString(2);

                while (formatedValue.length < 32) {
                  formatedValue = "0" + formatedValue;
                }

                let binary = "";
                let separatorAt = 4;
                for (let j = separatorAt; j < formatedValue.length + 1; j += separatorAt) {
                  binary += formatedValue.slice(j - separatorAt, j) + " ";
                }

                formatedValue = binary;

                formatedValue += "b";

                break;
              case "h":
                formatedValue = value.toString(16);
                formatedValue += "h";
                break;
              default:
                formatedValue = value;
                break;
            }

            /* this.$set(this.dataTableItems[i], "value", formatedValue); */
          }

          if (unit === undefined) {
            unit = "";
          }

          finalValue = formatedValue + " " + unit;

          this.$set(this.dataTableItems[i], "finalValue", finalValue);
        }
      }
      // Recorder
      else if ("recorder" in data) {
        this.recorder = data.recorder;
        if ("trigger" in data.recorder) {
          let operatorName = MyTriggers.GetOperatorName(this.recorder.trigger[2]);
          this.recorder.trigger.push(operatorName);
        }
      }
      // Events
      else if ("events" in data) {
        this.events = data.events;

        if (data.events.length != 0) {
          for (let index = 0; index < data.events.length; index++) {
            this.dataTableEventsItems.unshift(data.events[index]);
          }
          while (this.dataTableEventsItems.length > this.maxEvents) {
            this.dataTableEventsItems.pop();
          }
        }
      } else if ("sh" in data) {
        // Init

        this.recorderMaximumSamples = data.sh.samplesMax;
        this.recorderCurrentSample = 0;

        this.processRecorderChart("init", data.sh.variables, null);

        // Decimal to Hexa Conversion to following format 0000
        let sendFromSample = MyString.InsertZeroes(this.recorderCurrentSample.toString(), 4);
        let request = "DBG:sb" + sendFromSample + "\n";

        this.portWrite(request, true);
      } else if ("sb" in data) {
        this.recorderCurrentSample = data.sb.endSample;
        this.recorderCurrentSample = parseInt(this.recorderCurrentSample, 16);
        this.recorderCurrentSample++;
        this.recorderCurrentSample = this.recorderCurrentSample.toString(16).toUpperCase();

        if (parseInt(this.recorderCurrentSample, 16) < this.recorderMaximumSamples - 1) {
          // Decimal to Hexa Conversion to following format 0000
          let sendFromSample = MyString.InsertZeroes(this.recorderCurrentSample.toString(), 4);

          let request = "DBG:sb" + sendFromSample + "\n";

          this.portWrite(request, true);
        } else {
          let request = "DBG:sf" + "\n";

          this.portWrite(request, true);
        }

        this.processRecorderChart("run", null, data.sb.data);
      } else if ("sf" in data) {
        this.processRecorderChart("end", null, null);

        setTimeout(() => {
          this.rdRenderEN[this.tabsRecorder.length - 1] = false;
          this.timer.portWrite.enabled = true;
        }, 1000);
      }

      // Rd - Recorder Chart
      else if ("rd" in data) {
        if (this.version.ieee754Enabled === false) {
          // Prepare data before they are being pushed into array of arrays
          for (let i = 0; i < data.rd.length; i++) {
            for (let j = 0; j < data.rd[i].data.length; j++) {
              data.rd[i].data[j] /= 1000;
            }
          }
        }

        this.rd.push(data.rd);

        let lastIndex = this.rd.length - 1;

        // For every recorder data
        // Address is corrected to 64bits format
        for (let i = 0; i < this.rd[lastIndex].length; i++) {
          if (this.rd[lastIndex][i].name.length <= 8) {
            this.rd[lastIndex][i].name = "0X00000000" + this.rd[lastIndex][i].name;
          } else {
            this.rd[lastIndex][i].name = "0X" + this.rd[lastIndex][i].name;
          }
        }

        // For every recorder data
        // For every chart datasets, address is being searched in known address
        for (let i = 0; i < this.rd[lastIndex].length; i++) {
          for (let j = 0; j < this.variables.name.length; j++) {
            // When address is found, name is also known (at the same index)
            if (this.rd[lastIndex][i].name == this.variables.address[j]) {
              this.rd[lastIndex][i].name = this.variables.name[j];

              let gain;

              // Check if found variable have defined gain in recorder.json file
              for (let k = 0; k < this.recorderJSON.variables.length; k++) {
                if (this.recorderJSON.variables[k].name == this.rd[lastIndex][i].name) {
                  gain = this.recorderJSON.variables[k].gain;

                  if (gain != 0 && gain != 1 && gain != null) {
                    this.rd[lastIndex][i].name += "(x" + gain + ")";

                    for (let l = 0; l < this.rd[lastIndex][i].data.length; l++) {
                      this.$set(this.rd[lastIndex][i].data, l, Math.round(this.rd[lastIndex][i].data[l] * gain * 1000) / 1000);
                    }
                  }
                }
              }

              break;
            }
            // In case of no match, not found flag is added to address
            if (j == this.variables.name.length - 1) {
              this.rd[lastIndex][i].name = this.rd[lastIndex][i].name + " not found";
            }
          }
        }
      }

      this.timer.portWrite.enabled = true;
    },
    getPortsInformations() {
      /* SerialPort.list(); */

      SerialPort.list().then((ports, err) => {
        if (err) {
          console.log("getPortsInformations() Serial Port scan error: ", err.message);
        } else {
          this.paths = [];

          for (let index = 0; index < ports.length; index++) {
            this.paths[index] = ports[index].path;
          }
        }

        if (ports.length === 0) {
          console.log("getPortsInformations() No port found");
        }

        this.ports = [];

        for (let i = 0; i < ports.length; i++) {
          if (ports[i].manufacturer != undefined) {
            this.$set(this.ports, i, ports[i].path + " " + ports[i].manufacturer + " " + ports[i].productId + " " + ports[i].vendorId);
            this.$set(this.portsObj, i, ports[i]);
          }
        }
      });

      /*
      SerialPort.list().then((ports, err) => {
        if (err) {
          console.log("getPortsInformations() Serial Port scan error: ", err.message);
        } else {
          this.paths = [];

          for (let index = 0; index < ports.length; index++) {
            this.paths[index] = ports[index].path;
          }
        }

        if (ports.length === 0) {
          console.log("getPortsInformations() No port found");
        }

        this.ports = [];

        for (let i = 0; i < ports.length; i++) {
          if (ports[i].manufacturer != undefined) {
            this.$set(this.ports, i, ports[i].path + " " + ports[i].manufacturer + " " + ports[i].productId + " " + ports[i].vendorId);
            this.$set(this.portsObj, i, ports[i]);
          }
        }
      });
      */
    },
    pollPorts() {
      this.timer.portScan.set = setInterval(() => {
        this.getPortsInformations();
      }, this.timer.portScan.period);
    },
    pollData() {
      this.timer.portWrite.enabled = true;

      this.timer.portWrite.set = setInterval(() => {
        if (this.timer.portWrite.enabled === true) {
          this.getData();
        }
      }, this.timer.portWrite.period);
    },
    portWrite(request, lastEnabled) {
      if (constDebugMode === true) {
        console.log(request);
      }

      Port.write(request);

      if (lastEnabled === true) {
        this.requestLast = request;
      }
    },
    onResize() {
      this.getBreakpoints();
    },
    onKeyDown(event) {
      console.log(event.code);
      if (event.code == "ArrowUp" || event.code == "ArrowDown") {
        event.preventDefault();
      }
    },
    onKeyPress(event) {
      /*       console.log(event.key);
      console.log(event.code); */

      if (event.code == "Space") {
        event.preventDefault();
      }
      /*  */
    },
    onKeyUp(event) {
      let name = event.key;
      let code = event.code;

      let allowedKeys = ["i", "I"];
      let pass = allowedKeys.includes(name);

      /*   console.log(event.key);*/
      /*       console.log(event.code);
      if (event.code == "ArrowUp" || event.code == "ArrowDown") {
        event.preventDefault();
      } */

      // Triggers
      if (this.tabs == 2) {
        switch (name) {
          case "s":
          case "S":
            let saveObject;

            try {
              saveObject = JSON.stringify(this.dataTableTriggersItems, null, null);
              saveObject = MyJSON.FormatJSON(saveObject);

              console.log(saveObject);

              FileSystem.writeFile(this.triggerJSON.path, saveObject, function (err, data) {
                if (err) {
                  return console.log(err);
                }
                console.log(data);
              });

              this.snackbarInfo = true;
              this.snackbarInfoText = this.$t("service.snackbar.triggersSaved");
            } catch (error) {
              console.log(error);
              this.snackbarInfo = true;
              this.snackbarInfoText = this.$t("service.snackbar.triggersNotSaved");
            }
            break;

          case "x":
          case "X":
            // TODO
            break;

          default:
            break;
        }
      }

      if ((this.inspectPageSelect == null && !pass) || this.tabs != 0) {
        return;
      }

      if (this.dialog == true) {
        if (name == "Enter") {
          this.save();
        } else if (name == "Escape") {
          this.close();
        }

        return;
      }

      if (this.dialogSetVar == true) {
        if (name == "Enter") {
          this.saveSetVar();
        } else if (name == "Escape") {
          this.closeSetVar();
        }

        return;
      }

      if (this.dialogDelete == true) {
        if (name == "Enter") {
          this.deleteItemConfirm();
          if (this.dataTableItems.length != 0) {
            this.setDataTablePointer(0);
            this.dataTableSelected = [];
          }
        } else if (name == "Escape") {
          this.closeDelete();
        }

        return;
      }

      switch (code) {
        case "Space":
          // Označení/odznačení focusované proměnné
          for (let index = 0; index < this.dataTableItems.length; index++) {
            if (this.dataTableItems[index].selected == constSelected) {
              if (this.dataTableSelected.includes(this.dataTableItems[index].id)) {
                this.dataTableSelected.splice(this.dataTableSelected.indexOf(index), 1);
              } else {
                this.dataTableSelected.push(this.dataTableItems[index].id);
              }
            }
          }
          event.preventDefault();

          break;

        default:
          break;
      }

      if (code.includes("NumpadSubtract") === false && code.includes("NumpadAdd") === false) {
        if (code.includes("Numpad") === true || code.includes("Digit") === true) {
          let pageNumber;
          pageNumber = code.match(/\d+/g);
          if (pageNumber != null) {
            console.log("Page", pageNumber[0]);
          }

          this.changePageBuffer += pageNumber[0];

          if (this.timeoutPageBuffer == null) {
            this.timeoutPageBuffer = setTimeout(() => {
              let buff = parseInt(this.changePageBuffer);
              if (buff > 255) {
                buff = 255;
              }
              if (buff < 0) {
                buff = 0;
              }

              this.snackbarInfo = true;
              this.snackbarInfoText = this.$t("service.snackbar.setInspectPage") + buff + "!\n";

              let AllItems = this.$refs.SelectSetInspectPage.allItems;

              for (let index = 0; index < AllItems.length; index++) {
                if (AllItems[index].name.includes(buff)) {
                  this.snackbarInfoText += this.$t("service.snackbar.pageFound") + " " + AllItems[index].name + "!";
                  this.$refs.SelectSetInspectPage.setValue(AllItems[index].name);
                  break;
                }
                if (index == AllItems.length - 1) {
                  this.snackbarInfoText += this.$t("service.snackbar.pageNotFound");
                }
              }

              this.changePageBuffer = "";
              this.timeoutPageBuffer = null;
              return;
            }, 800);
          }
        }
      }

      switch (name) {
        case "A":
        case "a":
          // Přidání proměnné
          if (this.dataTableItems.length < 30) {
            this.dialog = true;
          } else {
            this.snackbarInfo = true;
            this.snackbarInfoText = this.$t("service.snackbar.fullPage");
          }

          break;
        case "E":
        case "e":
          // Editace proměnné
          for (let index = 0; index < this.dataTableItems.length; index++) {
            if (this.dataTableItems[index].selected == constSelected) {
              this.editItem(this.dataTableItems[index]);
            }
          }
          break;
        case "X":
        case "x":
          // Smazání proměnné
          for (let index = 0; index < this.dataTableItems.length; index++) {
            if (this.dataTableItems[index].selected == constSelected) {
              this.deleteItem(this.dataTableItems[index]);
            }
          }
          break;
        case "D":
        case "d":
          // Duplikace proměnné
          if (this.dataTableItems.length < 30) {
            this.dataTableItems.push(this.dataTableItems[this.dataTableSelectedId]);
            this.dataTableSelected = [];
            this.setDataTablePointer(this.dataTableSelectedId);
            this.recalculateDataTableId();
          } else {
            this.snackbarInfo = true;
            this.snackbarInfoText = this.$t("service.snackbar.fullPage");
          }
          break;
        case "O":
        case "o":
          // Posun proměnné nahoru
          if (this.dataTableSelectedId > 0) {
            const swap = this.dataTableItems[this.dataTableSelectedId];

            this.$set(this.dataTableItems, this.dataTableSelectedId, this.dataTableItems[this.dataTableSelectedId - 1]);
            this.$set(this.dataTableItems, this.dataTableSelectedId - 1, swap);

            this.dataTableSelected = [];
            this.dataTableSelectedId--;

            this.setDataTablePointer(this.dataTableSelectedId);
            this.recalculateDataTableId();
            this.sendRequestFromCurrentTable(this.inspectPageSelectId.toString(16).toUpperCase());
          }
          break;
        case "K":
        case "k":
          // Posun proměnné dolu
          if (this.dataTableSelectedId < this.dataTableItems.length - 1) {
            const swap = this.dataTableItems[this.dataTableSelectedId];

            this.$set(this.dataTableItems, this.dataTableSelectedId, this.dataTableItems[this.dataTableSelectedId + 1]);
            this.$set(this.dataTableItems, this.dataTableSelectedId + 1, swap);

            this.dataTableSelected = [];
            this.dataTableSelectedId++;

            this.setDataTablePointer(this.dataTableSelectedId);
            this.recalculateDataTableId();
            this.sendRequestFromCurrentTable(this.inspectPageSelectId.toString(16).toUpperCase());
          }
          break;
        case "-":
          // Decrement hodnoty
          this.prepareRequestAndSendRequest("Dec", this.dataTableItems[this.dataTableSelectedId]);
          break;
        case "+":
          // Inscrement hodnoty
          this.prepareRequestAndSendRequest("Inc", this.dataTableItems[this.dataTableSelectedId]);
          break;
        case "S":
        case "s":
          // Uložení sady
          this.saveInspectPage();
          break;
        case "I":
        case "i":
          this.$refs.SelectSetInspectPage.focus();

          // Zvolení inspekční sady
          if (this.$refs.SelectSetInspectPage.$_menuProps.value === true) {
            this.$refs.SelectSetInspectPage.blur();
          } else {
            this.$refs.SelectSetInspectPage.activateMenu();
          }
          break;
        case "Z":
        case "z":
        case "V":
        case "v":
          // Zadání nové hodnoty
          for (let index = 0; index < this.dataTableItems.length; index++) {
            if (this.dataTableItems[index].selected == constSelected) {
              this.setValue(this.dataTableItems[index]);
            }
          }
          break;
        case "H":
        case "h":
          for (let index = 0; index < this.dataTableItems.length; index++) {
            if (this.dataTableItems[index].selected == constSelected) {
              if (this.dataTableItems[index].format == "b") {
                if ("bits" in this.dataTableItems[index]) {
                  this.currentBits = this.dataTableItems[index].bits;
                  this.dialogBits = true;
                }
              }
            }
          }
          break;
        case "C":
        case "c":
          // Vynulování minima a maxima
          this.clearIntervalMaximumMinimum();

          this.snackbarInfo = true;
          this.snackbarInfoText = this.$t("service.snackbar.intervalsReset");
          break;
        case "P":
        case "p":
        case "ArrowUp":
          // Kurzor nahoru
          if (this.$refs.SelectSetInspectPage.$_menuProps.value === false) {
            this.moveUpDataTablePointer();
          }
          break;
        case "L":
        case "l":
        case "ArrowDown":
          // Kurzor dolů
          if (this.$refs.SelectSetInspectPage.$_menuProps.value === false) {
            this.moveDownDataTablePointer();
          }
          break;

        case "ArrowLeft":
          let LeftAllItems = this.$refs.SelectSetInspectPage.allItems;
          let LeftValue = this.$refs.SelectSetInspectPage.value;
          let LeftCurrentIndex;

          for (let index = 0; index < LeftAllItems.length; index++) {
            if (LeftValue == LeftAllItems[index].name) {
              LeftCurrentIndex = index;
            }
          }

          if (LeftCurrentIndex > 0) {
            LeftCurrentIndex--;
          }

          this.$refs.SelectSetInspectPage.setValue(LeftAllItems[LeftCurrentIndex].name);
          break;

        case "ArrowRight":
          let RightAllItems = this.$refs.SelectSetInspectPage.allItems;
          let RightValue = this.$refs.SelectSetInspectPage.value;
          let RightCurrentIndex;

          for (let index = 0; index < RightAllItems.length; index++) {
            if (RightValue == RightAllItems[index].name) {
              RightCurrentIndex = index;
            }
          }

          if (RightCurrentIndex < 255) {
            RightCurrentIndex++;
          }

          this.$refs.SelectSetInspectPage.setValue(RightAllItems[RightCurrentIndex].name);
          break;

        default:
          break;
      }
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth <= 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.dataTableItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.styleColor = item.style;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.dataTableItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.dataTableItems.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

      this.setInspectPage(true);
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

      this.dataTableSelected = [];

      this.recalculateDataTableId();
    },
    save() {
      /* console.log("save()"); */

      if (this.editedIndex > -1) {
        /* console.log("save() editedIndex > -1"); */
        Object.assign(this.dataTableItems[this.editedIndex], this.editedItem);
      } else {
        /* console.log("save() else"); */
        //this.editedItem.offset;

        let offset;

        switch (this.editedItem.type) {
          case "U8":
          case "I8":
            offset = 1;
            break;

          case "U16":
          case "I16":
            offset = 2;
            break;

          case "U32":
          case "I32":
          case "F0":
          case "F1":
          case "F2":
          case "F3":
          case "F6":
            offset = 4;
            break;

          default:
            offset = 0;
            break;
        }

        /*         if (this.editedItem.len > 0) {
          console.log("save() len > 0 ", this.editedItem.len);
          for (let index = 0; index < this.editedItem.len; index++) {
            this.editedItem.id = this.dataTableItems.length;
            this.editedItem.offset = index * offset;
            this.dataTableItems.push(this.editedItem);

            console.log("save() pushing items ", this.editedItem.offset);
          }
        } else {
          console.log("save() single push "); */
        this.dataTableItems.push(this.editedItem);
        /*         } */
      }
      this.close();
    },
    saveInspectPage() {
      // Get object 'path' based on selected name
      let inspectPageObj = this.inspectPages.find((obj) => obj.name === this.inspectPageSelect);

      console.warn(inspectPageObj);

      if (inspectPageObj.title == undefined) {
        inspectPageObj.title = "";
      }

      let saveOnlyFewThingsFromDataTable = [];
      let obj;

      for (let index = 0; index < this.dataTableItems.length; index++) {
        obj = {
          offset: this.dataTableItems[index].offset == undefined ? "" : this.dataTableItems[index].offset,
          name: this.dataTableItems[index].name == undefined ? "" : this.dataTableItems[index].name,
          type: this.dataTableItems[index].type == undefined ? "" : this.dataTableItems[index].type,
          format: this.dataTableItems[index].format == undefined ? "" : this.dataTableItems[index].format,
          gain: this.dataTableItems[index].gain == undefined ? "" : this.dataTableItems[index].gain,
          desc: this.dataTableItems[index].desc == undefined ? "" : this.dataTableItems[index].desc,
          units: this.dataTableItems[index].units == undefined ? "" : this.dataTableItems[index].units,
          style: this.dataTableItems[index].style == undefined ? "" : this.dataTableItems[index].style,
          x: this.dataTableItems[index].x == undefined ? "" : this.dataTableItems[index].x,
          y: this.dataTableItems[index].y == undefined ? "" : this.dataTableItems[index].y,
        };

        if (obj.name == "") {
          delete obj.name;
        }
        if (obj.x == "") {
          delete obj.x;
        }
        if (obj.y == "") {
          delete obj.y;
        }
        if (obj.style == "") {
          delete obj.style;
        }
        if (obj.type == "") {
          delete obj.type;
        }
        if (obj.desc == "") {
          delete obj.desc;
        }
        if (obj.offset == "") {
          delete obj.offset;
        }
        if (obj.format == "") {
          delete obj.format;
        }
        if (obj.gain == "") {
          delete obj.gain;
        }
        if (obj.units == "") {
          delete obj.units;
        }

        saveOnlyFewThingsFromDataTable.push(obj);
      }

      let saveObject = {
        variables: saveOnlyFewThingsFromDataTable,
        controls: this.dataTableControlItems,
        background: this.dataTableBackgroundItems,
        title: inspectPageObj.title,
      };

      console.log(inspectPageObj.path);

      try {
        saveObject = JSON.stringify(saveObject, null, null);
        saveObject = MyJSON.FormatJSON(saveObject);

        // console.log(saveObject);
        console.warn(inspectPageObj.path);

        FileSystem.writeFile(inspectPageObj.path, saveObject, function (err, data) {
          if (err) {
            return console.log(err);
          }
          console.log(data);
        });

        /*

        this.inspectPages = [];

        this.scanDirectoryAndParseFiles("./" + this.filesPath, ".json");

        this.openEveryFileAndParseName();

        */

        this.snackbarInfo = true;
        this.snackbarInfoText = this.$t("service.snackbar.pageSaved");
      } catch (error) {
        console.log(error);
        this.snackbarInfo = true;
        this.snackbarInfoText = this.$t("service.snackbar.pageNotSaved");
      }
    },
    sendCommand(item) {
      let index = this.dataTableControlItems.indexOf(item);

      let name = this.dataTableControlItems[index].name;
      let offset = this.dataTableControlItems[index].offset;
      let type = this.dataTableControlItems[index].type;

      let typeValue = MyVariables.GetTypeValue(type);

      let value = this.dataTableControlItems[index].value;

      let address;
      let finalAddress;

      for (let i = 0; i < this.variables.name.length; i++) {
        if (name == this.variables.name[i]) {
          address = this.variables.address[i];

          finalAddress = (parseInt(address) + offset).toString(16).toUpperCase();

          break;
        }

        if (i == this.variables.name.length - 1) {
          return;
        }
      }

      finalAddress = finalAddress.substr(finalAddress.length - 8, finalAddress.length);

      if (this.version.ieee754Enabled === true) {
        if (MyVariables.IsTypeFloat(type)) {
          value = MyMath.Float2Hexa(parseFloat(value));
        } else if (MyVariables.IsTypeInteger(type)) {
          value = MyMath.Int2Hexa(parseInt(value));
        }
      } else {
        value = MyMath.Int2Hexa(parseInt(value));
      }

      let request = "DBG:vw:" + finalAddress + "," + typeValue + "," + value;

      this.portWrite(request, false);

      this.snackbarInfo = true;
      this.snackbarInfoText = this.$t("service.snackbar.valueSet");
    },
    setValue(item) {
      this.dialogSetVar = true;

      let index = this.dataTableItems.indexOf(item);
      let address = this.dataTableItems[index].finalAddress;
      let type = this.dataTableItems[index].type;
      let typeValue = MyVariables.GetTypeValue(type);
      let value = this.dataTableItems[index].value;

      this.setVariable.address = address.substr(address.length - 8, address.length);
      this.setVariable.typeValue = typeValue;
      this.setVariable.type = type;
      this.setVariable.value = value;

      setTimeout(() => {
        this.$refs.TextFieldSetVar.focus();
      }, 180);
    },
    closeSetVar() {
      this.dialogSetVar = false;

      this.setVariable.typeValue = 0;
      this.setVariable.address = "";
      this.setVariable.type = "";
      this.setVariable.value = "";
    },
    saveSetVar() {
      this.dialogSetVar = false;

      let value = this.setVariable.value;
      let type = this.setVariable.type;

      if (this.version.ieee754Enabled === true) {
        if (MyVariables.IsTypeFloat(type)) {
          value = MyMath.Float2Hexa(parseFloat(value));
        } else if (MyVariables.IsTypeInteger(type)) {
          value = MyMath.Int2Hexa(parseInt(value));
        }
      } else {
        value = MyMath.Int2Hexa(parseInt(value));
      }

      this.sendRequest(value, this.setVariable.address, this.setVariable.typeValue);
    },
    prepareRequestAndSendRequest(operation, row) {
      let value = row.value;
      let address = row.address;
      let type = row.type;

      if (operation === "Inc") {
        value = value + MyVariables.GetIncrementDecrementGain(type);
      } else if (operation === "Dec") {
        value = value - MyVariables.GetIncrementDecrementGain(type);
      }

      if (this.version.ieee754Enabled === true) {
        if (MyVariables.IsTypeFloat(type)) {
          value = MyMath.Float2Hexa(parseFloat(value));
        } else if (MyVariables.IsTypeInteger(type)) {
          value = MyMath.Int2Hexa(parseInt(value));
        }
      } else {
        value = MyMath.Int2Hexa(parseInt(value));
      }

      address = address.substr(address.length - 8, address.length);

      this.sendRequest(value, address, MyVariables.GetTypeValue(type));
    },
    sendRequest(value, address, type) {
      let request = "DBG:vw:" + address + "," + type + "," + value;

      this.portWrite(request, false);

      this.snackbarInfo = true;
      this.snackbarInfoText = this.$t("service.snackbar.valueSet");
    },
    setRealTimeChart() {
      let obj;
      this.rt = [];

      for (let index = 0; index < this.dataTableItems.length; index++) {
        if (this.dataTableSelected.includes(this.dataTableItems[index].id)) {
          obj = {
            index: index,
            name: this.dataTableItems[index].name,
            dataRaw: [],
            data: [],
            gain: 1,
          };

          this.rt.push(obj);
        }
      }
    },
    setStyleColor() {
      if (this.editedItem.color != undefined && this.editedItem.backgroundColor != undefined) {
        this.editedItem.styleColor = this.editedItem.color + this.editedItem.backgroundColor;
      } else if (this.editedItem.color != undefined) {
        this.editedItem.styleColor = this.editedItem.color;
      } else if (this.editedItem.backgroundColor != undefined) {
        this.editedItem.styleColor = this.editedItem.backgroundColor;
      } else {
        this.editedItem.styleColor = "";
      }
    },
    tglBitTableRowClick(row) {
      if (row.value === 0) {
        this.$set(this.currentBits[row.index], "value", 1);
      } else {
        this.$set(this.currentBits[row.index], "value", 0);
      }

      let value = 0;

      for (let index = 0; index < this.currentBits.length; index++) {
        if (this.currentBits[index].value === 1) {
          value += 1 << index;
        }
      }

      for (let index = 0; index < this.dataTableItems.length; index++) {
        if (this.dataTableItems[index].selected == constSelected) {
          let finalAddress = this.dataTableItems[index].finalAddress;
          let formatedAddress = finalAddress.substr(finalAddress.length - 8, finalAddress.length);

          let typeValue = MyVariables.GetTypeValue(this.dataTableItems[index].type);

          //console.log("value", value);

          let finalValue = (value >>> 0).toString(16).toUpperCase();

          //console.log("finalValue", finalValue);

          while (finalValue.length < 8) {
            finalValue = "0" + finalValue;
          }

          let request = "DBG:vw:" + formatedAddress + "," + typeValue + "," + finalValue;

          this.portWrite(request, false);

          this.snackbarInfo = true;
          this.snackbarInfoText = this.$t("service.snackbar.valueSet");
        }
      }
    },
    getBitTableRowStyle(row) {
      if (row.value === 1) {
        return "background-color: " + this.$vuetify.theme.themes.light.primary + "; color: white"; //  #607D8B";
      } else {
        return "background-color: #EEEEEE" + "; color: gray";
      }
    },
    setFinalStyle() {
      let style = "";

      if (this.editedItem.styleColor != undefined && this.editedItem.styleColor != "" && this.editedItem.styleFont != undefined && this.editedItem.styleFont != "") {
        style = this.editedItem.styleColor + this.editedItem.styleFont; //
      } else if (this.editedItem.styleColor != undefined && this.editedItem.styleColor != "") {
        style = this.editedItem.styleColor;
      } else if (this.editedItem.styleFont != undefined && this.editedItem.styleFont != "") {
        style = this.editedItem.styleFont;
      }

      this.editedItem.style = style;
    },
    setImageStyle(item, object) {
      let index = object.indexOf(item);

      let left = object[index].x;
      let top = object[index].y;

      let size = MyMath.LineEquation_LimitedByExtremePoints(0, 4, 3950, 18, this.windowWidth);

      let style = object[index].style != null ? object[index].style : "";

      return "position: absolute; " + "left:" + left + "%; " + "top:" + top + "%; " + "font-size: " + 0.75 * size + "px; " + style;
    },
    getImageControlStyle(item) {
      return this.setImageStyle(item, this.dataTableControlItems);
    },
    getImageSpanStyle(item) {
      return this.setImageStyle(item, this.dataTableItems);
    },
    getTriggerStyle(data) {
      let value = data.value;
      let condVal = MyTriggers.GetOperatorValue(data.cond);
      let typeVal = MyVariables.GetTypeValue(data.type);

      let address = "";
      for (let index = 0; index < this.variables.name.length; index++) {
        if (this.variables.name[index] == data.name) {
          address = this.variables.address[index];
        }
      }

      value = parseFloat(value);

      /*    console.log("address", address);
      console.log("typeVal", typeVal);
      console.log("condVal", condVal);
      console.log("value", value);
      console.log("this.recorder.trigger[0]", "0X00000000" + this.recorder.trigger[0]);
      console.log("this.recorder.trigger[1]", this.recorder.trigger[1]);
      console.log("this.recorder.trigger[2]", this.recorder.trigger[2]);
      console.log("this.recorder.trigger[3]", this.recorder.trigger[3]); */

      if (address == "0X00000000" + this.recorder.trigger[0]) {
        if (typeVal == this.recorder.trigger[1]) {
          if (condVal == this.recorder.trigger[2]) {
            if (value == this.recorder.trigger[3]) {
              console.log("EQ");
              return "background-color: #E53935;";
            }
          }
        }
      }

      return "background-color: #ECEFF1;";
    },
    getActionColor(data) {
      let index = this.dataTableItems.indexOf(data);

      if (this.dataTableItems[index].finalAddress == "0X0000000000000000") {
        return "white";
      } else {
        return "black";
      }
    },
    getStyle(data) {
      let index = this.dataTableItems.indexOf(data);

      if (this.dataTableItems[index].finalAddress == "0X0000000000000000") {
        return "background-color: black; color: white";
      }

      let style = this.dataTableItems[index].style;

      return style;
    },
    getStyle2(data, from) {
      let currentItem = this.dataTableItems[this.dataTableItems.indexOf(data)];

      let style1 = "font-size: 10px;"; // font-style: oblique";
      let style2 = "font-size: 10px;"; // font-style: oblique";

      let regNumber = /\d+/;

      let intervals = currentItem.intervals;
      let format = currentItem.format;

      if (from == "intervals") {
        if (intervals == undefined) {
          return;
        } else {
          if (intervals.includes("|")) {
            return style1;
          } else if (!intervals.match(regNumber)) {
            return style2;
          }
        }
      } else if (from == "finalValue") {
        if (format == "b" || format == "h") {
          return style1;
        }
      }
    },
    dataTableRowClick(data) {
      this.dataTableSelectedId = data.id;

      this.setDataTablePointer(this.dataTableItems.indexOf(data));
    },
    dataTableCheckBoxClick() {
      //console.log("dataTableCheckBoxClick()");
    },
    dataTableSortByE() {
      this.dataTableSelected = [];
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      window.addEventListener("keypress", this.onKeyPress);
      window.addEventListener("keyup", this.onKeyUp);
      window.addEventListener("keydown", this.onKeyDown);
    });

    if (this.isDesktop === true) {
      this.pollPorts();
      this.pollData();
    }
  },

  created() {
    let info = "";

    if (isElectron() === true) {
      SerialPort = require("serialport").SerialPort;
      ReadlineParser = require("@serialport/parser-readline").ReadlineParser;

      FileSystem = require("fs");
      FilePath = require("path");

      this.files = [];

      this.scanDirectory("./", ".json");
      this.scanDirectory("./", ".map");

      /*       this.scanDirectory("./Inverter", ".json");
      this.scanDirectory("./Inverter", ".map");
      this.scanDirectory("./MPPT", ".json");
      this.scanDirectory("./MPPT", ".map"); */

      /*       function addPath(arr, obj = {}) {
        let component = arr.shift();
        let current = obj[component] || (obj[component] = { name: component });
        if (arr.length) {
          addPath(arr, current.children || (current.children = {}));
        }
        return obj;
      }

      function makeArray(obj) {
        let arr = Object.values(obj);
        arr
          .filter((item) => item.children)
          .forEach((item) => {
            item.children = makeArray(item.children);
          });
        return arr;
      }

      let treeObj = this.files.reduce((obj, path) => addPath(path.split("/"), obj), {});

      let arr = makeArray(treeObj);

      this.files = arr; */

      /* console.log(this.files); */

      try {
        this.config = JSON.parse(FileSystem.readFileSync(FilePath.resolve("users", "..", "ECSConfig.json"), { encoding: "utf8", flag: "r" }));

        info += this.$i18n.t("service.snackbar.basicConfigLoaded") + "\n";
        console.log(this.config);

        if ("variableDesc" in this.config) {
          try {
            this.variablesDesc = JSON.parse(FileSystem.readFileSync(FilePath.resolve("users", "..", this.config.variableDesc), "utf8"));
            info += this.$i18n.t("service.snackbar.variableDescLoaded") + "\n";
          } catch (error) {
            info += this.$i18n.t("service.snackbar.variableDescNotLoaded") + "\n";
          }
        }
        if ("baudrate" in this.config) {
          this.serialSettings.baudRate = this.config.baudrate;
          info += this.$i18n.t("service.snackbar.baudrateLoaded") + "\n";
        }
        if ("port" in this.config) {
          this.port = this.config.port;
          this.setPort(this.config.port);
          info += this.$i18n.t("service.snackbar.serialPreferedPort") + "\n";
        }
        if ("release" in this.config) {
          this.filesPath = this.config.release;
          this.changeProjectPointer();
        }
        if ("map" in this.config) {
          if (this.config.map.length != 0) {
            const pathMap = FilePath.resolve("users", "..", this.config.map);
            const mapFile = FileSystem.readFileSync(pathMap, "utf8");
            this.parseMap(mapFile);
            this.searchAddressForGivenNames();
            this.fileInputLabel = this.config.map;
            info += this.$i18n.t("service.snackbar.mapLoaded") + "\n";
          }
        }
      } catch (error) {
        console.log(error);

        info += this.$i18n.t("service.snackbar.basicConfigNotLoaded") + "\n";

        // TODO Vytvořit defaultní ECSConfig.json
      }

      for (let index = 0; index < constMaximumRecorderCharts; index++) {
        this.rdRenderEN[index] = false;
      }

      try {
        this.ECSVariables = JSON.parse(FileSystem.readFileSync(FilePath.resolve("users", "..", "ECSVariables.json"), { encoding: "utf8", flag: "r" }));
      } catch (error) {
        console.log(error);
        info += this.$i18n.t("service.snackbar.ECSVariablesNotLoaded") + "\n";
      }

      this.isDesktop = true;

      /*
      try {
        const fpath = FilePath.resolve("users", "..", "ECSConfig.json");
        this.config = JSON.parse(FileSystem.readFileSync(fpath));
        info += "Konfigurace načtena \n";

        if ("variableDesc" in this.config) {
          try {
            this.variablesDesc = JSON.parse(FileSystem.readFileSync(FilePath.resolve("users", "..", this.config.variableDesc), "utf8"));
            info += "Popisky proměnných načteny!\n";
          } catch (error) {
            info += "Nepodařilo se načíst popisky!\n";
          }
        }
        if ("map" in this.config) {
          if (this.config.map.length != 0) {
            const pathMap = FilePath.resolve("users", "..", this.config.map);
            const mapFile = FileSystem.readFileSync(pathMap, "utf8");
            this.parseMap(mapFile);
            this.searchAddressForGivenNames();
            this.fileInputLabel = this.config.map;
            info += "Mapa proměnných načtena!\n";
          }
        }
        if ("inspect" in this.config) {
          this.scanDirectory("./" + this.config.inspect, ".json");
          this.openEveryFileAndParseName();
          info += "Inspektové sady načteny!\n";
        }
        if ("baudrate" in this.config) {
          this.serialSettings.baudRate = this.config.baudrate;
          info += "Komunikační rychlost načtena!\n";
        }
        if ("port" in this.config) {
          this.port = this.config.port;
          this.setPort(this.config.port);
          info += "Seriový port načten (nastavuji)!\n";
        }
      } catch (error) {
        console.log(error);

        info += "Nelze načíst konfigurační soubor! Proveďte prosím manuální nastavení aplikace!\n";

        // Vytvořit defaultní ECSConfig.json
      }
      */
    }

    this.snackbarInfo = true;
    this.snackbarInfoText = info;

    if (this.isDesktop === true) {
      this.getPortsInformations();
    }
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("keypress", this.onKeyPress);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("keydown", this.onKeyDown);

    this.closeActivePort();

    if (this.timer.portScan.set != null) {
      clearInterval(this.timer.portScan.set);
    }
    if (this.timer.portWrite.set != null) {
      clearInterval(this.timer.portWrite.set);
    }
    if (this.timer.variableSample.set != null) {
      clearInterval(this.timer.variableSample.set);
    }
    if (this.timer.requestChart.set != null) {
      clearInterval(this.timer.requestChart.set);
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogSetVar(val) {
      val || this.closeSetVar();
    },
    editedIndex() {
      if (this.editedIndex == -1) {
        this.searchAddressForGivenNames();
      }
    },
    tabs() {
      console.log(this.tabs);
      console.log(this.poolWasActive);

      if (this.tabs == 1) {
        this.poolWasActive = true;
      } else {
        if (this.poolWasActive === true) {
          if (this.tabs == 0) {
            this.setInspectPage(false);
          }
        }

        this.poolWasActive = false;
      }

      console.log(this.poolWasActive);

      /*       if (this.tabs == 0) {
        this.setInspectPage(false);
      } */
    },
    "editedItem.btnTglFont": function () {
      this.editedItem.styleFont = "";

      if (this.editedItem.btnTglFont != undefined) {
        if (this.editedItem.btnTglFont.includes(0)) {
          this.editedItem.styleFont += "font-weight: bold;";
        }
        if (this.editedItem.btnTglFont.includes(1)) {
          this.editedItem.styleFont += "font-style: italic;";
        }
        if (this.editedItem.btnTglFont.includes(2)) {
          this.editedItem.styleFont += "text-decoration: underline;";
        }
      }

      this.setFinalStyle();
    },
    "editedItem.btnTglColor": function () {
      if (this.editedItem.btnTglColor != undefined) {
        if (this.editedItem.btnTglColor.includes(0)) {
          this.editedItem.backgroundColor = "background-color:" + this.colorPicker.hexa + ";";
        }
        if (this.editedItem.btnTglColor.includes(1)) {
          this.editedItem.color = "color:" + this.colorPicker.hexa + ";";
        }

        this.setStyleColor();
      }

      this.setFinalStyle();
    },
    colorPicker() {
      if (this.editedItem.btnTglColor != undefined) {
        if (this.editedItem.btnTglColor.includes(0)) {
          this.editedItem.backgroundColor = "background-color:" + this.colorPicker.hexa + ";";
        }
        if (this.editedItem.btnTglColor.includes(1)) {
          this.editedItem.color = "color:" + this.colorPicker.hexa + ";";
        }

        this.setStyleColor();
      }

      this.setFinalStyle();
    },
    /*     loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 2000);

      this.loader = null;
    }, */
  },
};
</script>

<style scoped>
td {
  white-space: nowrap;
}
</style>
